//crie a estrutura basica
import React from 'react';
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "../Globalstyle";
import { lightTheme, darkTheme } from "../Themes"
import { Routes, Route } from "react-router-dom";
import Login from '../Login';
import { useTranslation } from 'react-i18next';
import NotFound from '../NotFound/NotFound';
import { TemaContext } from '../../common/context/TemaContext';
import { LinguagemContext } from '../../common/context/LinguagemContext';
import { UsuarioContext } from '../../common/context/UsuarioContext';
import {useContext, useRef, useState, useMemo, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import Moment from 'react-moment';
import Accordion from 'react-bootstrap/Accordion';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styled from 'styled-components';
import { Line } from 'react-chartjs-2';
import style from './WebBased.module.css'
import { FormControl, InputLabel,MenuItem, Select, Autocomplete, Box, Slider, TextField, OutlinedInput, Stack, Chip } from '@mui/material';
//import { MenuItem, Select, Box, FormControl, InputLabel, MenuItem, Select, Slider, TextField, OutlinedInput, Stack, Chip, Autocomplete, Tabs, Paper, Tab } from '@mui/material';
import './WebBased.css';
import Translator from '../I18n/Translator';
import { addDays, startOfYear, startOfWeek, endOfWeek,format, setWeek, getISOWeek, differenceInCalendarDays } from 'date-fns';
import { enUS, te } from 'date-fns/locale';
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import { use } from 'i18next';
import TabNav from '../TabNav';
import { ServerContext } from '../../common/context/ServerContext';
import CookieService from '../../service/CookieService';


var _logado = "";

function WebBased() {
  function getCookie(name) {
      // Cria uma expressão regular para encontrar o cookie pelo nome
      const cookieName = name + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(';');
    
      // Percorre todos os cookies para encontrar o desejado
      for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1);
        }
        if (cookie.indexOf(cookieName) === 0) {
          return cookie.substring(cookieName.length, cookie.length);
        }
      }
      return "";
  }

  const dadosCoriza = useRef([]);
  const dadosCovid = useRef([]);
  const dadosDiarreia = useRef([]);
  const dadosDorDeCabeca = useRef([]);
  const dadosDorDeGarganta = useRef([]);
  const dadosFaltaDeAr = useRef([]);
  const dadosFebre = useRef([]);
  const dadosGripe = useRef([]);
  const dadosResfriado = useRef([]);
  const dadosTosse = useRef([]);
  const dadosVomito = useRef([]);
  const dadosGripal = useRef([]);

  const dadosCorizaMediaMovel = useRef([]);
  const dadosCovidMediaMovel = useRef([]);
  const dadosDiarreiaMediaMovel = useRef([]);
  const dadosDorDeCabecaMediaMovel = useRef([]);
  const dadosDorDeGargantaMediaMovel = useRef([]);
  const dadosFaltaDeArMediaMovel = useRef([]);
  const dadosFebreMediaMovel = useRef([]);
  const dadosGripeMediaMovel = useRef([]);
  const dadosResfriadoMediaMovel = useRef([]);
  const dadosTosseMediaMovel = useRef([]);
  const dadosVomitoMediaMovel= useRef([]);
  const dadosGripalMediaMovel = useRef([]);
  const prioridade = useRef([]);

  const [datas, setDatas] = useState([]);
  const [minIdxDate, setMinIdxDate] = useState(0);
  const [maxIdxDate, setMaxIdxDate] = useState(0);

  const [municipios, setMunicipios] = useState();

  var texto_grafico_dark = "#fff";
  var texto_grafico_light = "#000";
  var fontGrafico = 10;

  var cod_estados = [
    {"UF":"AC",
    "COD": 12, "NOME":"Acre"},
    {"UF":"AL",
    "COD": 27, "NOME":"Alagoas"},
    {"UF":"AP",
    "COD": 16, "NOME":"Amapá"},
    {"UF":"AM",
    "COD": 13, "NOME":"Amazonas"},
    {"UF":"BA",
    "COD": 29, "NOME":"Bahia"},
    {"UF":"CE",
    "COD": 23, "NOME":"Ceará"},
    {"UF":"DF",
    "COD": 53, "NOME":"Distrito Federal"},
    {"UF":"ES",
    "COD": 32, "NOME":"Espírito Santo"},
    {"UF":"GO",
    "COD": 52, "NOME":"Goiás"},
    {"UF":"MA",
    "COD": 21, "NOME":"Maranhão"},
    {"UF":"MT",
    "COD": 51, "NOME":"Mato Grosso"},
    {"UF":"MS",
    "COD": 50, "NOME":"Mato Grosso do Sul"},
    {"UF":"MG",
    "COD": 31, "NOME":"Minas Gerais"},
    {"UF":"PA",
    "COD": 15, "NOME":"Pará"},
    {"UF":"PB",
    "COD": 25, "NOME":"Paraíba"},
    {"UF":"PR",
    "COD": 41, "NOME":"Paraná"},
    {"UF":"PE",
    "COD": 26, "NOME":"Pernambuco"},
    {"UF":"PI",
    "COD": 22, "NOME":"Piauí"},
    {"UF":"RJ",
    "COD": 33, "NOME":"Rio de Janeiro"},
    {"UF":"RN",
    "COD": 24, "NOME":"Rio Grande do Norte"},
    {"UF":"RS",
    "COD": 43, "NOME":"Rio Grande do Sul"},
    {"UF":"RO",
    "COD": 11,"NOME":"Rondônia"},
    {"UF":"RR",
    "COD": 14,"NOME":"Roraima"},
    {"UF":"SC",
    "COD": 42,"NOME":"Santa Catarina"},        
    {"UF":"SP",
    "COD": 35,"NOME":"São Paulo"},
    {"UF":"SE",
    "COD": 28,"NOME":"Sergipe"},
    {"UF":"TO",
    "COD": 17,"NOME":"Tocantins"},
];

  const [ocultaCoriza, setOcultaCoriza] = useState(false);
  const [ocultaCovid, setOcultaCovid] = useState(false);
  const [ocultaDiarreia, setOcultaDiarreia] = useState(false);
  const [ocultaDorDeCabeca, setOcultaDorDeCabeca] = useState(false);
  const [ocultaDorDeGarganta, setOcultaDorDeGarganta] = useState(false);
  const [ocultaFaltaDeAr, setOcultaFaltaDeAr] = useState(false);
  const [ocultaFebre, setOcultaFebre] = useState(false);
  const [ocultaGripe, setOcultaGripe] = useState(false);
  const [ocultaResfriado, setOcultaResfriado] = useState(false);
  const [ocultaTosse, setOcultaTosse] = useState(false);
  const [ocultaVomito, setOcultaVomito] = useState(false);
  const [ocultaGripal, setOcultaGripal] = useState(false);

  const [ultimoValorCovid, setUltimoValorCovid] = useState(null);
  const [ultimoValorCoriza, setUltimoValorCoriza] = useState(null);
  const [ultimoValorDiarreia, setUltimoValorDiarreia] = useState(null);
  const [ultimoValorDorDeCabeca, setUltimoValorDorDeCabeca] = useState(null);
  const [ultimoValorDorDeGarganta, setUltimoValorDorDeGarganta] = useState(null);
  const [ultimoValorFaltaDeAr, setUltimoValorFaltaDeAr] = useState(null);
  const [ultimoValorFebre, setUltimoValorFebre] = useState(null);
  const [ultimoValorGripe, setUltimoValorGripe] = useState(null);
  const [ultimoValorResfriado, setUltimoValorResfriado] = useState(null);
  const [ultimoValorTosse, setUltimoValorTosse] = useState(null);
  const [ultimoValorVomito, setUltimoValorVomito] = useState(null);

  const [ultimoValorCovidMM, setUltimoValorCovidMM] = useState(null);
  const [ultimoValorCorizaMM, setUltimoValorCorizaMM] = useState(null);
  const [ultimoValorDiarreiaMM, setUltimoValorDiarreiaMM] = useState(null);
  const [ultimoValorDorDeCabecaMM, setUltimoValorDorDeCabecaMM] = useState(null);
  const [ultimoValorDorDeGargantaMM, setUltimoValorDorDeGargantaMM] = useState(null);
  const [ultimoValorFaltaDeArMM, setUltimoValorFaltaDeArMM] = useState(null);
  const [ultimoValorFebreMM, setUltimoValorFebreMM] = useState(null);
  const [ultimoValorGripeMM, setUltimoValorGripeMM] = useState(null);
  const [ultimoValorResfriadoMM, setUltimoValorResfriadoMM] = useState(null);
  const [ultimoValorTosseMM, setUltimoValorTosseMM] = useState(null);
  const [ultimoValorVomitoMM, setUltimoValorVomitoMM] = useState(null);
  const [ultimoValorAPS, setUltimoValorAPS] = useState(null);

  const [exibeBotoes, setExibeBotoes] = useState(true);

  const atualizandoGrafico = useRef(false);
  const contadorReescala = useRef(0);

  const chartRef = useRef(null);

  const legenda = [];

  const {theme} = useContext(TemaContext);
  const {logado, setLogado} = useContext(UsuarioContext);		
  const {language} = useContext(LinguagemContext);
  const {servidor} = useContext(ServerContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const [mediaMovelSelecionada, setMediaMovelSelecionada] = useState("1");
  const [variavelMediaMovelSelecionada, setVariavelMediaMovelSelecionada] = useState("1");

  
          const carregandoEstado = useRef(false);
          const [carregouCache, setCarregouCache] = useState(false);
          const [filtrandoMunicipio, setFiltrandoMunicipio] = useState(false);

  const getHora = () => {
    const now = new Date();
    const timeWithMs = `${now.getHours().toString().padStart(2, '0')}:` +
                      `${now.getMinutes().toString().padStart(2, '0')}:` +
                      `${now.getSeconds().toString().padStart(2, '0')}.` +
                      `${now.getMilliseconds().toString().padStart(3, '0')}`;

    return timeWithMs;
  }

  const darkenRGBA = (rgbaStr, percentage) => {
    // Parse the RGBA string
    const rgba = rgbaStr.match(/\d+/g).map(Number);
    const [r, g, b, a] = rgba;
  
    // Calculate the darkened values
    const factor = 1 - (percentage / 100);
    const newR = Math.max(0, Math.min(255, Math.floor(r * factor)));
    const newG = Math.max(0, Math.min(255, Math.floor(g * factor)));
    const newB = Math.max(0, Math.min(255, Math.floor(b * factor)));
  
    // Return the new RGBA string
    return `rgba(${newR}, ${newG}, ${newB}, ${a})`;
  };

  const normalizaDados = (data) => {
    //const dates = Object.keys(data);
    
    let dataInicial = datas[minIdxDate];
    let dataFinal = datas[maxIdxDate];

    const dates = Object.keys(data).filter(date => date >= dataInicial && date <= dataFinal);

    if (dates.length === 0) return [];
  
    // Extrair os valores de 'total'
    let valores = dates.map(date => data[date]);
  
    // Encontrar o valor máximo em 'total'
    let max = Math.max(...valores);

    let multiplicador = 100 / max;
  
    // Normalizar os valores de 'total' e manter os campos 'data'
    let normalizedData = dates.map(date => {
      return {
        data: date,
        total : data[date] * multiplicador
      };
    });

    normalizedData = Object.fromEntries(
      normalizedData.map(({data, total}) => [data, total])
    );
  
    return normalizedData;
  };

  const getDadosGrafico = (
    dados_total_atendimentos_gripais, dados, fullScreen, 
    titulo_atendimento_gripais, titulo, borderColor2, 
    backgroundColor2) => {
    return {
        legenda,
        datasets: [
            {
                fill: true,
                label: titulo_atendimento_gripais,
                data: dados_total_atendimentos_gripais,
                borderColor: corAtendimentosGripais,
                backgroundColor: corBackgroundAtendimentosGripais,
                borderWidth: fullScreen ? 2 : 1,
                pointBorderWidth: fullScreen ? 2 : 1.5,
                pointRadius: fullScreen ? 1.5 : 1.3,
                yAxisID: 'y',
            },
            {
                fill: true,
                label: titulo,
                data: dados,
                borderColor: borderColor2,
                backgroundColor: backgroundColor2,
                borderWidth: fullScreen ? 2 : 1,
                pointBorderWidth: fullScreen ? 2 : 1.5,
                pointRadius: fullScreen ? 1.5 : 1.3,
                yAxisID: 'y2',
            },
            
        ],

    };
  }

  const getDadosGraficoTodos = (titulo_atendimento_gripais, dados_total_atendimentos_gripais, titulo, dados, titulo2, dados2, titulo3, dados3, titulo4, dados4, titulo5, dados5, titulo6, dados6, titulo7, dados7, titulo8, dados8, titulo9, dados9, titulo10, dados10, titulo11, dados11, fullScreen) => {
    return {
        legenda,
        datasets: [
            {
                cubicInterpolationMode: 'monotone',
                fill: false,
                label: titulo_atendimento_gripais,
                data: dados_total_atendimentos_gripais,
                borderColor: /*corAtendimentosGripais*/'red',
                backgroundColor: /*corBackgroundAtendimentosGripais*/ 'red',
                borderWidth: fullScreen ? 6 : 3,
                pointBorderWidth: fullScreen ? 2 : 1.5,
                pointRadius: 0,
                yAxisID: 'y',
                hidden:false,
            },
            {
                cubicInterpolationMode: 'monotone',
                fill: false,
                label: titulo,
                data: dados,
                borderColor: borderColor2,
                backgroundColor: backgroundColor2,
                borderWidth: fullScreen ? 2 : 1,
                pointBorderWidth: fullScreen ? 2 : 1.5,
                pointRadius: 0,
                yAxisID: 'y2',
                hidden: dados === null || dados.length === 0 ? true : false,
            },
            {
                cubicInterpolationMode: 'monotone',
                fill: false,
                label: titulo2,
                data: dados2,
                borderColor: borderColor3,
                backgroundColor: backgroundColor3,
                borderWidth: fullScreen ? 2 : 1,
                pointBorderWidth: fullScreen ? 2 : 1.5,
                pointRadius: 0,
                yAxisID: 'y2',
                hidden: dados2 === null || dados2.length === 0 ? true : false,
            },
            {
                cubicInterpolationMode: 'monotone',
                fill: false,
                label: titulo3,
                data: dados3,
                borderColor: borderColor4,
                backgroundColor: backgroundColor4,
                borderWidth: fullScreen ? 2 : 1,
                pointBorderWidth: fullScreen ? 2 : 1.5,
                pointRadius: 0,
                yAxisID: 'y2',
                hidden: dados3 === null || dados3.length === 0 ? true : false,
            },
            {
              cubicInterpolationMode: 'monotone',
                fill: false,
                label: titulo4,
                data: dados4,
                borderColor: borderColor5,
                backgroundColor: backgroundColor5,
                borderWidth: fullScreen ? 2 : 1,
                pointBorderWidth: fullScreen ? 2 : 1.5,
                pointRadius: 0,
                yAxisID: 'y2',
                hidden: dados4 === null || dados4.length === 0 ? true : false,
            },
            {
              cubicInterpolationMode: 'monotone',  
              fill: false,
              label: titulo5,
              data: dados5,
              borderColor: borderColor6,
              backgroundColor: backgroundColor6,
              borderWidth: fullScreen ? 2 : 1,
              pointBorderWidth: fullScreen ? 2 : 1.5,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden: dados5 === null || dados5.length === 0 ? true : false,
          },
          {
            cubicInterpolationMode: 'monotone',
              fill: false,
              label: titulo6,
              data: dados6,
              borderColor: borderColor7,
              backgroundColor: backgroundColor7,
              borderWidth: fullScreen ? 2 : 1,
              pointBorderWidth: fullScreen ? 2 : 1.5,
              pointRadius: 0,
              yAxisID: 'y2',  
              hidden:  dados6 === null || dados6.length === 0 ? true : false,
          },
          {
            cubicInterpolationMode: 'monotone',
              fill: false,
              label: titulo7,
              data: dados7,
              borderColor: borderColor8,
              backgroundColor: backgroundColor8,
              borderWidth: fullScreen ? 2 : 1,
              pointBorderWidth: fullScreen ? 2 : 1.5,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:  dados7 === null || dados7.length === 0 ? true :false,
          },
          {
            cubicInterpolationMode: 'monotone',
            fill: false,
            label: titulo8,
            data: dados8,
            borderColor: borderColor9,
            backgroundColor: backgroundColor9,
            borderWidth: fullScreen ? 2 : 1,
            pointBorderWidth: fullScreen ? 2 : 1.5,
            pointRadius: 0,
            yAxisID: 'y2',
            hidden: dados8 === null || dados8.length === 0 ? true : false,
          },
          {
            cubicInterpolationMode: 'monotone',
              fill: false,
              label: titulo9,
              data: dados9,
              borderColor: borderColor10,
              backgroundColor: backgroundColor10,
              borderWidth: fullScreen ? 2 : 1,
              pointBorderWidth: fullScreen ? 2 : 1.5,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden: dados9 === null || dados9.length === 0 ? true : false,
          },
          {
            cubicInterpolationMode: 'monotone',
              fill: false,
              label: titulo10,
              data: dados10,
              borderColor: borderColor11,
              backgroundColor: backgroundColor11,
              borderWidth: fullScreen ? 2 : 1,
              pointBorderWidth: fullScreen ? 2 : 1.5,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden: dados10 === null || dados10.length === 0 ? true : false,
          },
          {
            cubicInterpolationMode: 'monotone',
              fill: false,
              label: titulo11,
              data: dados11,
              borderColor: borderColor12,
              backgroundColor: backgroundColor12,
              borderWidth: fullScreen ? 2 : 1,
              pointBorderWidth: fullScreen ? 2 : 1.5,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden: dados11 === null || dados11.length === 0 ? true :  false,
          }, 
        ],

    };
  }

  const getDadosMediaGraficoTodos = (titulo_atendimento_gripais, dados_total_atendimentos_gripais, titulo, dados, titulo2, dados2, titulo3, dados3, titulo4, dados4, titulo5, dados5, titulo6, dados6, titulo7, dados7, titulo8, dados8, titulo9, dados9, titulo10, dados10, titulo11, dados11, fullScreen) => {
    let corMediaMovelAzul = "#175b8fff";
    let borderWidthMediaMovel = fullScreen ? 4 : 2;
    let pointBorderWidthMediaMovel = fullScreen ? 4 : 3;
    let dataLocal = [];
    let dataLocalMediaMovel = [];
    switch (variavelMediaMovelSelecionada) {
        case "1":
          dataLocal = {
              cubicInterpolationMode: 'monotone',
              fill: false,
              label: titulo,
              data: normalizaDados(dadosCoriza.current),
              borderColor: borderColor2,
              backgroundColor:  backgroundColor2,
              borderWidth: fullScreen ? 2 : 1,
              pointBorderWidth: fullScreen ? 2 : 1.5,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:false,
          };
          dataLocalMediaMovel = {
              cubicInterpolationMode: 'monotone',
              fill: false,
              label: t("dashboard.graficos.legenda_mm.1") + " " + titulo,
              data: dados,
              borderColor: corMediaMovelAzul,
              backgroundColor: corMediaMovelAzul,
              borderWidth: borderWidthMediaMovel,
              pointBorderWidth: pointBorderWidthMediaMovel,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:false,
          };
          break;
        case "2":
          dataLocal = {
            cubicInterpolationMode: 'monotone',
            fill: false,
            label: titulo2,
            data: normalizaDados(dadosCovid.current),
            borderColor: borderColor3,
            backgroundColor: backgroundColor3,
            borderWidth: fullScreen ? 2 : 1,
            pointBorderWidth: fullScreen ? 2 : 1.5,
            pointRadius: 0,
            yAxisID: 'y2',
            hidden:false,
        };
          dataLocalMediaMovel = {
              cubicInterpolationMode: 'monotone',
              fill: false,
              label: t("dashboard.graficos.legenda_mm.1") + " " + titulo2,
              data: dados2,
              borderColor: corMediaMovelAzul,
              backgroundColor: corMediaMovelAzul,
              borderWidth: borderWidthMediaMovel,
              pointBorderWidth: pointBorderWidthMediaMovel,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:false,
          };
          break;
        case "3":
          dataLocal = {
            cubicInterpolationMode: 'monotone',
            fill: false,
            label: titulo3,
            data: normalizaDados(dadosDiarreia.current),
            borderColor: borderColor4,
            backgroundColor: backgroundColor4,
            borderWidth: fullScreen ? 2 : 1,
            pointBorderWidth: fullScreen ? 2 : 1.5,
            pointRadius: 0,
            yAxisID: 'y2',
            hidden:false,
        };
          dataLocalMediaMovel = {
              cubicInterpolationMode: 'monotone',
              fill: false,
              label: t("dashboard.graficos.legenda_mm.1") + " " + titulo3,
              data: dados3,
              borderColor: corMediaMovelAzul,
              backgroundColor: corMediaMovelAzul,
              borderWidth: borderWidthMediaMovel,
              pointBorderWidth: pointBorderWidthMediaMovel,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:false,
          };
          break;
        case "4":
          dataLocal = {
            cubicInterpolationMode: 'monotone',
            fill: false,
            label: titulo4,
            data: normalizaDados(dadosDorDeCabeca.current),
            borderColor: borderColor5,
            backgroundColor: backgroundColor5,
            borderWidth: fullScreen ? 2 : 1,
            pointBorderWidth: fullScreen ? 2 : 1.5,
            pointRadius: 0,
            yAxisID: 'y2',
            hidden:false,
        };
          dataLocalMediaMovel = {
              cubicInterpolationMode: 'monotone',
              fill: false,
              label: t("dashboard.graficos.legenda_mm.1") + " " + titulo4,
              data: dados4,
              borderColor: corMediaMovelAzul,
              backgroundColor: corMediaMovelAzul,
              borderWidth: borderWidthMediaMovel,
              pointBorderWidth: pointBorderWidthMediaMovel,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:false,
          };
          break;
        case "5":
          dataLocal = {
            cubicInterpolationMode: 'monotone',
            fill: false,
            label: titulo5,
            data: normalizaDados(dadosDorDeGarganta.current),
            borderColor: borderColor6,
            backgroundColor: backgroundColor6,
            borderWidth: fullScreen ? 2 : 1,
            pointBorderWidth: fullScreen ? 2 : 1.5,
            pointRadius: 0,
            yAxisID: 'y2',
            hidden:false,
        };
          dataLocalMediaMovel = {
              cubicInterpolationMode: 'monotone',
              fill: false,
              label: t("dashboard.graficos.legenda_mm.1") + " " + titulo5,
              data: dados5,
              borderColor: corMediaMovelAzul,
              backgroundColor: corMediaMovelAzul,
              borderWidth: borderWidthMediaMovel,
              pointBorderWidth: pointBorderWidthMediaMovel,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:false,
          };
          break;
        case "6":
          dataLocal = {
            cubicInterpolationMode: 'monotone',
            fill: false,
            label: titulo6,
            data: normalizaDados(dadosFaltaDeAr.current),
            borderColor: borderColor7,
            backgroundColor: backgroundColor7,
            borderWidth: fullScreen ? 2 : 1,
            pointBorderWidth: fullScreen ? 2 : 1.5,
            pointRadius: 0,
            yAxisID: 'y2',
            hidden:false,
        };
          dataLocalMediaMovel = {
              cubicInterpolationMode: 'monotone',
              fill: false,
              label: t("dashboard.graficos.legenda_mm.1") + " " +titulo6,
              data: dados6,
              borderColor: corMediaMovelAzul,
              backgroundColor: corMediaMovelAzul,
              borderWidth: borderWidthMediaMovel,
              pointBorderWidth: pointBorderWidthMediaMovel,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:false,
          };
          break;
        case "7":
          dataLocal = {
            cubicInterpolationMode: 'monotone',
            fill: false,
            label: titulo7,
            data: normalizaDados(dadosFebre.current),
            borderColor: borderColor8,
            backgroundColor: backgroundColor8,
            borderWidth: fullScreen ? 2 : 1,
            pointBorderWidth: fullScreen ? 2 : 1.5,
            pointRadius: 0,
            yAxisID: 'y2',
            hidden:false,
        };
          dataLocalMediaMovel = {
              cubicInterpolationMode: 'monotone',
              fill: false,
              label: t("dashboard.graficos.legenda_mm.1") + " " + titulo7,
              data: dados7,
              borderColor: corMediaMovelAzul,
              backgroundColor: corMediaMovelAzul,
              borderWidth: borderWidthMediaMovel,
              pointBorderWidth: pointBorderWidthMediaMovel,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:false,
          };
          break;
        case "8":
          dataLocal = {
            cubicInterpolationMode: 'monotone',
            fill: false,
            label: titulo8,
            data: normalizaDados(dadosGripe.current),
            borderColor: borderColor9,
            backgroundColor: backgroundColor9,
            borderWidth: fullScreen ? 2 : 1,
            pointBorderWidth: fullScreen ? 2 : 1.5,
            pointRadius: 0,
            yAxisID: 'y2',
            hidden:false,
        };
          dataLocalMediaMovel = {
              cubicInterpolationMode: 'monotone',
              fill: false,
              label: t("dashboard.graficos.legenda_mm.1") + " " + titulo8,
              data: dados8,
              borderColor: corMediaMovelAzul,
              backgroundColor: corMediaMovelAzul,
              borderWidth: borderWidthMediaMovel,
              pointBorderWidth: pointBorderWidthMediaMovel,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:false,
          };
          break;
        case "9":
          dataLocal = {
            cubicInterpolationMode: 'monotone',
            fill: false,
            label: titulo9,
            data: normalizaDados(dadosResfriado.current),
            borderColor: borderColor10,
            backgroundColor: backgroundColor10,
            borderWidth: fullScreen ? 2 : 1,
            pointBorderWidth: fullScreen ? 2 : 1.5,
            pointRadius: 0,
            yAxisID: 'y2',
            hidden:false,
        };
          dataLocalMediaMovel = {
              cubicInterpolationMode: 'monotone',
              fill: false,
              label: t("dashboard.graficos.legenda_mm.1") + " " + titulo9,
              data: dados9,
              borderColor: corMediaMovelAzul,
              backgroundColor: corMediaMovelAzul,
              borderWidth: borderWidthMediaMovel,
              pointBorderWidth: pointBorderWidthMediaMovel,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:false,
          };
          break;
        case "10":
          dataLocal = {
            cubicInterpolationMode: 'monotone',
            fill: false,
            label: titulo10,
            data: normalizaDados(dadosTosse.current),
            borderColor: borderColor11,
            backgroundColor: backgroundColor11,
            borderWidth: fullScreen ? 2 : 1,
            pointBorderWidth: fullScreen ? 2 : 1.5,
            pointRadius: 0,
            yAxisID: 'y2',
            hidden:false,
        };
          dataLocalMediaMovel = {
              cubicInterpolationMode: 'monotone',
              fill: false,
              label: t("dashboard.graficos.legenda_mm.1") + " " + titulo10,
              data: dados10,
              borderColor: corMediaMovelAzul,
              backgroundColor: corMediaMovelAzul,
              borderWidth: borderWidthMediaMovel,
              pointBorderWidth: pointBorderWidthMediaMovel,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:false,
          };
          break;
        case "11":
          dataLocal = {
            cubicInterpolationMode: 'monotone',
            fill: false,
            label: titulo11,
            data: normalizaDados(dadosVomito.current),
            borderColor: borderColor12,
            backgroundColor: backgroundColor12,
            borderWidth: fullScreen ? 2 : 1,
            pointBorderWidth: fullScreen ? 2 : 1.5,
            pointRadius: 0,
            yAxisID: 'y2',
            hidden:false,
        };
          dataLocalMediaMovel = {
              cubicInterpolationMode: 'monotone',
              fill: false,
              label: t("dashboard.graficos.legenda_mm.1") + " " + titulo11,
              data: dados11,
              borderColor: corMediaMovelAzul,
              backgroundColor: corMediaMovelAzul,
              borderWidth: borderWidthMediaMovel,
              pointBorderWidth: pointBorderWidthMediaMovel,
              pointRadius: 0,
              yAxisID: 'y2',
              hidden:false,
          };
          break;
    }
    return {
        legenda,
        datasets: [
            {
                cubicInterpolationMode: 'monotone',
                fill: false,
                label: titulo_atendimento_gripais,
                data: dados_total_atendimentos_gripais,
                borderColor: /*corAtendimentosGripais*/'red',
                backgroundColor: /*corBackgroundAtendimentosGripais*/ 'red',
                borderWidth: fullScreen ? 6 : 3,
                pointBorderWidth: fullScreen ? 2 : 1.5,
                pointRadius: 0,
                yAxisID: 'y',
                hidden:false,
            },
            dataLocal,
            dataLocalMediaMovel,
        ],

    };
  }

  const corAtendimentosGripais = useMemo(() => {
    return '#2fb4ef';
  }, []);   

  const corBackgroundAtendimentosGripais = useMemo(() => {
    return 'rgba(47, 180, 239, 0.5)';
  }, []); 

  const borderColor2 = useMemo(() => {
    return "#E6194B"; // Vermelho
}, []);

const backgroundColor2 = useMemo(() => { 
    return "rgba(230, 25, 75, 0.5)";
}, []);

const borderColor2_mm = useMemo(() => {
  return "#ab1338"; // Vermelho
}, []);

const backgroundColor2_mm = useMemo(() => { 
  return "rgba(171, 19, 56, 0.5)";
}, []);

const borderColor3 = useMemo(() => {
    return "#3CB44B"; // Verde
}, []);

const backgroundColor3 = useMemo(() => { 
    return "rgba(60, 180, 75, 0.5)";
}, []);

const borderColor3_mm = useMemo(() => {
  return "#2b8236"; // Verde
}, []);

const backgroundColor3_mm = useMemo(() => { 
  return "rgba(43, 130, 54, 0.5)";
}, []);

const borderColor4 = useMemo(() => {
    return "#FFE119"; // Amarelo
}, []);

const backgroundColor4 = useMemo(() => { 
    return "rgba(255, 225, 25, 0.5)";
}, []);

const borderColor4_mm = useMemo(() => {
  return "#bda713"; // Amarelo
}, []);

const backgroundColor4_mm = useMemo(() => { 
  return "rgba(189, 167, 19, 0.5)";
}, []);

const borderColor5 = useMemo(() => {
    return "#4363D8"; // Azul
}, []);

const backgroundColor5 = useMemo(() => { 
    return "rgba(70, 130, 180, 0.5)";
}, []);

const borderColor5_mm = useMemo(() => {
  return "#334ca6"; // Azul
}, []);

const backgroundColor5_mm = useMemo(() => { 
  return "rgba(51, 76, 166, 0.5)";
}, []);

const borderColor6 = useMemo(() => {
    return "#F58231"; // Laranja
}, []);

const backgroundColor6 = useMemo(() => { 
    return "rgba(245, 130, 48, 0.5)";
}, []);

const borderColor6_mm = useMemo(() => {
  return "#c96b28"; // Laranja
}, []);

const backgroundColor6_mm = useMemo(() => { 
  return "rgba(201, 107, 40, 0.5)";
}, []);

const borderColor7 = useMemo(() => {
    return "#911EB4"; // Roxo
}, []);

const backgroundColor7 = useMemo(() => { 
    return "rgba(145, 30, 180, 0.5)";
}, []);

const borderColor7_mm = useMemo(() => {
    return "#73178f"; // Roxo
}, []);

const backgroundColor7_mm = useMemo(() => {
    return "rgba(115, 23, 143, 0.5)";
}, []);

const borderColor8 = useMemo(() => {
    return "#46F0F0"; // Ciano
}, []);

const backgroundColor8 = useMemo(() => { 
    return "rgba(70, 240, 240, 0.5)";
}, []);

const borderColor8_mm = useMemo(() => {
  return "#35b8b8"; // Ciano
}, []);

const backgroundColor8_mm = useMemo(() => {
  return "rgba(53, 184, 184, 0.5)";
}, []);

const borderColor9 = useMemo(() => {
    return "#F032E6"; // Magenta
}, []);

const backgroundColor9 = useMemo(() => { 
    return "rgba(240, 50, 230, 0.5)";
}, []);

const borderColor9_mm = useMemo(() => {
  return "#b526ae"; // Magenta
}, []);

const backgroundColor9_mm = useMemo(() => { 
  return "rgba(181, 38, 174, 0.5)";
}, []);

const borderColor10 = useMemo(() => {
    return "#800000"; // Marrom
}, []);

const backgroundColor10 = useMemo(() => { 
    return "rgba(128, 0, 0, 0.5)";
}, []);

const borderColor10_mm = useMemo(() => {
  return "#6e0101"; // Marrom
}, []);

const backgroundColor10_mm = useMemo(() => { 
  return "rgba(110, 1, 1, 0.5)";
}, []);

const borderColor11 = useMemo(() => {
    return "#808000"; // Oliva
}, []);

const backgroundColor11 = useMemo(() => { 
    return "rgba(128, 128, 0, 0.5)";
}, []);

const borderColor11_mm = useMemo(() => {
  return "#4f4f00"; // Oliva
}, []);

const backgroundColor11_mm = useMemo(() => { 
  return "rgba(79, 79, 0, 0.5)";
}, []);

const borderColor12 = useMemo(() => {
    return "#808080"; // Cinza
}, []);

const backgroundColor12 = useMemo(() => { 
    return "rgba(128, 128, 128, 0.5)";
}, []);

const borderColor12_mm = useMemo(() => {
  return "#404040"; // Cinza
}, []);

const backgroundColor12_mm = useMemo(() => { 
  return "rgba(64, 64, 64, 0.5)";
}, []);

  const [dadosAtendimentoCoriza, setDadosAtendimentoCoriza] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", t("dashboard.variaveisGoogle.coriza"))
  );

  const [dadosAtendimentoCovid, setDadosAtendimentoCovid] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Covid")
  );

  const [dadosAtendimentoDiarreia, setDadosAtendimentoDiarreia] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Diarreia")
  );

  const [dadosAtendimentoDorDeCabeca, setDadosAtendimentoDorDeCabeca] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Dor de Cabeça")
  );

  const [dadosAtendimentoDorDeGarganta, setDadosAtendimentoDorDeGarganta] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Dor de Garganta")
  );

  const [dadosAtendimentoFaltaDeAr, setDadosAtendimentoFaltaDeAr] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Falta de Ar")
  );

  const [dadosAtendimentoFebre, setDadosAtendimentoFebre] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Febre")
  );

  const [dadosAtendimentoGripe, setDadosAtendimentoGripe] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Gripe")
  );

  const [dadosAtendimentoResfriado, setDadosAtendimentoResfriado] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Resfriado")
  );

  const [dadosAtendimentoTosse, setDadosAtendimentoTosse] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Tosse")
  );

  const [dadosAtendimentoVomito, setDadosAtendimentoVomito] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Vomito")
  );

  const [dadosAtendimentoTodos, setDadosAtendimentoTodos] = useState(
    getDadosGraficoTodos("Atendimentos Gripais", null, t("dashboard.variaveisGoogle.coriza"), null, "Covid", null, "Diarreia", null, "Dor de Cabeça", null, "Dor de Garganta", null, "Falta de Ar", null, "Febre", null, "Gripe", null, "Resfriado", null, "Tosse", null, "Vomito", null, false)
  );

  const [dadosMediaAtendimentoTodos, setDadosMediaAtendimentoTodos] = useState(
    getDadosMediaGraficoTodos("Atendimentos Gripais", null, t("dashboard.variaveisGoogle.coriza"), null, "Covid", null, "Diarreia", null, "Dor de Cabeça", null, "Dor de Garganta", null, "Falta de Ar", null, "Febre", null, "Gripe", null, "Resfriado", null, "Tosse", null, "Vomito", null, false)
  );

  const [dadosAtendimentoCorizaMediaMovel, setDadosAtendimentoCorizaMediaMovel] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", t("dashboard.variaveisGoogle.coriza"))
  );

  const [dadosAtendimentoCovidMediaMovel, setDadosAtendimentoCovidMediaMovel] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Covid")
  );

  const [dadosAtendimentoDiarreiaMediaMovel, setDadosAtendimentoDiarreiaMediaMovel] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Diarreia")
  );

  const [dadosAtendimentoDorDeCabecaMediaMovel, setDadosAtendimentoDorDeCabecaMediaMovel] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Dor de Cabeça")
  );

  const [dadosAtendimentoDorDeGargantaMediaMovel, setDadosAtendimentoDorDeGargantaMediaMovel] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Dor de Garganta")
  );

  const [dadosAtendimentoFaltaDeArMediaMovel, setDadosAtendimentoFaltaDeArMediaMovel] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Falta de Ar")
  );

  const [dadosAtendimentoFebreMediaMovel, setDadosAtendimentoFebreMediaMovel] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Febre")
  );

  const [dadosAtendimentoGripeMediaMovel, setDadosAtendimentoGripeMediaMovel] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Gripe")
  );

  const [dadosAtendimentoResfriadoMediaMovel, setDadosAtendimentoResfriadoMediaMovel] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Resfriado")
  );

  const [dadosAtendimentoTosseMediaMovel, setDadosAtendimentoTosseMediaMovel] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Tosse")
  );

  const [dadosAtendimentoVomitoMediaMovel, setDadosAtendimentoVomitoMediaMovel] = useState(
    getDadosGrafico(null, null, false, "Atendimentos Gripais", "Vomito")
  );

  const [dadosAtendimentoTodosMediaMovel, setDadosAtendimentoTodosMediaMovel] = useState(
    getDadosGraficoTodos("Atendimentos Gripais", null, "Coriza", null, "Covid", null, "Diarreia", null, "Dor de Cabeça", null, "Dor de Garganta", null, "Falta de Ar", null, "Febre", null, "Gripe", null, "Resfriado", null, "Tosse", null, "Vomito", null, false)
  );

  const [minDate, setMinDate] = useState(null);
  const [minDateRangeInicial, setMinDateRangeInicial] = useState(null);
  const [minDateRangeFinal, setMinDateRangeFinal] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [maxDateRangeInicial, setMaxDateRangeInicial] = useState(null);
  const [maxDateRangeFinal, setMaxDateRangeFinal] = useState(null);
  const [inicioSemanaSelecionada, setInicioSemanaSelecionada] = useState(null);
  const [fimSemanaSelecionada, setFimSemanaSelecionada] = useState(null);
  const [inicioSemanaSelecionadaRange, setInicioSemanaSelecionadaRange] = useState(null);
  const [fimSemanaSelecionadaRange, setFimSemanaSelecionadaRange] = useState(null);

  const [semanas, setSemanas] = useState([]);
  const [inicioSemanas, setInicioSemanas] = useState([]);
  const [fimSemanas, setFimSemanas] = useState([]);
  
  
  const dataInicial = useRef(new Date("2023-01-01"));

  const [valueRangeData, setValueRangeData] = useState([0,0]);
  
  function compararPorData(a, b) {
    const dataA = new Date(a.data);
    const dataB = new Date(b.data);
    return dataA - dataB;
  }
  /*
  A média da relação percentual (covid-gripe) é aproximadamente 21.35%
A média da relação percentual (gripe-febre) é aproximadamente 46.58%
A média da relação percentual (gripe-tosse) é aproximadamente 27.46%
A média da relação percentual (gripe-diarreia) é aproximadamente 19.66%
A média da relação percentual (gripe-dor_de_cabeca) é aproximadamente 13.46%
A média da relação percentual (gripe-coriza) é aproximadamente 6.76%
A média da relação percentual (gripe-dor_de_garganta) é aproximadamente 9.99%
A média da relação percentual (gripe-falta_de_ar) é aproximadamente 10.29%
A média da relação percentual (gripe-resfriado) é aproximadamente 11.25%
A média da relação percentual (gripe-vomito) é aproximadamente 4.91%
    */

  let media_gripe = {
    "febre": 0.4658,
    "tosse": 0.2746,
    "diarreia": 0.1966,
    "dor_de_cabeca": 0.1346,
    "resfriado": 0.1125,
    "falta_de_ar": 0.1029,
    "dor_de_garganta": 0.0999,
    "coriza": 0.0676,   
    "vomito":0.0491
  }
  
  let media_covid = {
    "gripe":0.2135,
    "febre": 0.4658*0.2135,
    "tosse": 0.2746*0.2135,
    "diarreia": 0.1966*0.2135,
    "dor_de_cabeca": 0.1346*0.2135,
    "resfriado": 0.1125*0.2135,
    "falta_de_ar": 0.1029*0.2135,
    "dor_de_garganta": 0.0999*0.2135,
    "coriza": 0.0676*0.2135,   
    "vomito":0.0491*0.2135
  }


  const atualizaRangeGraficos = (valor, tipo, validacao) => {
    //console.log("atualizaRangeGraficos",valor, tipo, validacao);
    if(validacao){
        if(tipo === "max"){
            if(parseInt(valor) <= (parseInt(minIdxDate) + 1)){
                return;
            }
        } else {
            if(parseInt(valor) >= (parseInt(maxIdxDate) - 1) ){
                valor = parseInt(maxIdxDate) - 2;
                //return;
            }
        } 
    }

    /*let maior = tipo === "max" ? parseInt(valor) : maxIdxDate;
    let menor = tipo === "min" ? parseInt(valor) : minIdxDate;

    var minPercent = getPercent(parseInt(menor));
    var maxPercent = getPercent(parseInt(maior));*/

    if (tipo === "max") {
        setMaxDate(datas[valor]);
        //console.log("maxDate",datas[valor]);
        setFimSemanaSelecionada(fimSemanas[valor]);
        setMaxIdxDate(valor);
        setValueRangeData([minIdxDate,valor]);
        
        setInicioSemanaSelecionadaRange(semanas[minIdxDate]);
        setFimSemanaSelecionadaRange(semanas[valor]);

        setMinDateRangeInicial(inicioSemanas[minIdxDate]);
        setMinDateRangeFinal(fimSemanas[minIdxDate]);
        setMaxDateRangeInicial(inicioSemanas[valor]);
        setMaxDateRangeFinal(fimSemanas[valor]);

        /*setSizeRange({width: (maxPercent - minPercent) + "%", left: sizeRange.left});*/
        ////filtrarMunicipio(municipioSelecionado, false, props.data,"",datas[minIdxDate],datas[valor]);
        
    } else {
        setMinDate(datas[valor]);
        setMinDateRangeInicial(inicioSemanas[valor]);
        setMinDateRangeFinal(fimSemanas[valor]);
        setMaxDateRangeInicial(inicioSemanas[maxIdxDate]);
        setMaxDateRangeFinal(fimSemanas[maxIdxDate]);

        setInicioSemanaSelecionadaRange(semanas[valor]);
        setFimSemanaSelecionadaRange(semanas[maxIdxDate]);
        
        //console.log("maxDate",datas[valor]);
        setMinIdxDate(valor);

        /*let idxDataInicio = getIdxDataInicio(datas);
        setMinDate(datas[idxDataInicio]);
        setMinIdxDate(idxDataInicio);*/
        
        setValueRangeData([valor,maxIdxDate]);

        /*
        if(maxPercent > 85)
            maxPercent = 85;*/

        /*setSizeRange({width: (maxPercent - minPercent) + "%", left: minPercent+ "%"});*/
        ////filtrarMunicipio(municipioSelecionado, false,props.data,"",datas[valor],datas[maxIdxDate]);
    }
  }

  useEffect(() => {
    /*if(cod_ibge === t("dashboard.todos")){
      carregaDadosMunicipio(t("dashboard.todos"));
    } 
    else   
    if(!isAllSelect(cod_ibge)){
      carregaDadosMunicipio(cod_ibge);
    }*/
    if(prioridade.current[1]){
      let exibe0 = !getOcultar(prioridade.current[0]["nome"]) ? prioridade.current[0]["nome"] : "";
      let exibe1 = !getOcultar(prioridade.current[1]["nome"]) ? prioridade.current[1]["nome"] : "";
      let exibe2 = !getOcultar(prioridade.current[2]["nome"]) ? prioridade.current[2]["nome"] : "";
      let exibe3 = !getOcultar(prioridade.current[3]["nome"]) ? prioridade.current[3]["nome"] : "";
      let exibe4 = !getOcultar(prioridade.current[4]["nome"]) ? prioridade.current[4]["nome"] : "";
      let exibe5 = !getOcultar(prioridade.current[5]["nome"]) ? prioridade.current[5]["nome"] : "";
      let exibe6 = !getOcultar(prioridade.current[6]["nome"]) ? prioridade.current[6]["nome"] : "";
      let exibe7 = !getOcultar(prioridade.current[7]["nome"]) ? prioridade.current[7]["nome"] : "";
      let exibe8 = !getOcultar(prioridade.current[8]["nome"]) ? prioridade.current[8]["nome"] : "";
      let exibe9 = !getOcultar(prioridade.current[9]["nome"]) ? prioridade.current[9]["nome"] : "";
      let exibe10 = !getOcultar(prioridade.current[10]["nome"]) ? prioridade.current[10]["nome"] : "";

      //console.log(prioridade[0]["nome"], prioridade[1]["nome"], prioridade[2]["nome"], prioridade[3]["nome"], prioridade[4]["nome"], prioridade[5]["nome"], prioridade[6]["nome"], prioridade[7]["nome"], prioridade[8]["nome"], prioridade[9]["nome"], prioridade[10]["nome"])
      //console.log(minIdxDate, maxIdxDate, tempDatas.length, tempDatas[0], tempDatas[tempDatas.length - 1], tempDatas);
      //console.log(exibe0, exibe1, exibe2, exibe3, exibe4, exibe5, exibe6, exibe7, exibe8, exibe9, exibe10);

      //console.log(dadosCoriza.current, dadosCovid.current, dadosDiarreia.current, dadosDorDeCabeca.current, dadosDorDeGarganta.current, dadosFaltaDeAr.current, dadosFebre.current, dadosGripe.current, dadosResfriado.current, dadosTosse.current, dadosVomito.current, dadosGripal.current);

      //console.log("atualizaGraficoRelativo");
      //console.log("chamada atualizaGraficoRelativo valueRangeData", getHora());
      atualizaGraficoRelativo([exibe0, exibe1, exibe2, exibe3, exibe4, exibe5, exibe6, exibe7, exibe8, exibe9, exibe10]);
      
      atualizaMediaMovel();
    }
  },[valueRangeData]);

  const handleChangeRangeData = (event, newValue) => {
    if(newValue[0] !== minIdxDate){
        atualizaRangeGraficos(newValue[0], "min", true);
    } else if(newValue[1] !== maxIdxDate) {    
        atualizaRangeGraficos(newValue[1], "max", true);
    }
  };

  const isAllSelect = (variavel) => {
    return variavel === "All" || variavel === "Todos";
  }

  function calculo_sintomas_relativos(termos, y1, y2, y3, y4, y5, y6, y7, y8, y9, y10, y11) {
    let y1_ = 0
    let y2_ = 0
    let y3_ = 0
    let y4_ = 0
    let y5_ = 0
    let y6_ = 0
    let y7_ = 0
    let y8_ = 0 
    let y9_ = 0
    let y10_ = 0
    let y11_ = 0

    if (termos[0] != "") {
        y1_ = y1 * prioridade.current[0]["perc"]
      if (termos[1] != "")
        y2_ = y2 * prioridade.current[1]["perc"]
      if (termos[2] != "")
        y3_ = y3 * prioridade.current[2]["perc"]
      if (termos[3] != "")
        y4_ = y4 * prioridade.current[3]["perc"]
      if (termos[4] != "")
        y5_ = y5 * prioridade.current[4]["perc"]
      if (termos[5] != "")
        y6_ = y6 * prioridade.current[5]["perc"]
      if (termos[6] != "")
        y7_ = y7 * prioridade.current[6]["perc"]
      if (termos[7] != "")
        y8_ = y8 * prioridade.current[7]["perc"]
      if (termos[8] != "")
        y9_ = y9 * prioridade.current[8]["perc"]
      if (termos[9] != "")
        y10_ = y10 * prioridade.current[9]["perc"]
      if (termos[10] != "")
        y11_ = y11 * prioridade.current[10]["perc"]
    }
        
    else if (termos[1] != "") {
      y2_ = y2 * prioridade.current[1]["perc"]
      if (termos[2] != "")
        y3_ = y3 * prioridade.current[2]["perc"]
      if (termos[3] != "")
        y4_ = y4 * prioridade.current[3]["perc"]
      if (termos[4] != "")
        y5_ = y5 * prioridade.current[4]["perc"]
      if (termos[5] != "")
        y6_ = y6 * prioridade.current[5]["perc"]
      if (termos[6] != "")
        y7_ = y7 * prioridade.current[6]["perc"]
      if (termos[7] != "")
        y8_ = y8 * prioridade.current[7]["perc"]
      if (termos[8] != "")
        y9_ = y9 * prioridade.current[8]["perc"]
      if (termos[9] != "")
        y10_ = y10 * prioridade.current[9]["perc"]
      if (termos[10] != "")
        y11_ = y11 * prioridade.current[10]["perc"]
    }
        
    else if (termos[2] != "") {
      /*y2_ = y2*/
      y3_ = y3 * prioridade.current[2]["perc"]
      if (termos[3] != "")
        y4_ = y4 * prioridade.current[3]["perc"]
      if (termos[4] != "")
        y5_ = y5 * prioridade.current[4]["perc"]
      if (termos[5] != "")
        y6_ = y6 * prioridade.current[5]["perc"]
      if (termos[6] != "")
        y7_ = y7 * prioridade.current[6]["perc"]
      if (termos[7] != "")
        y8_ = y8 * prioridade.current[7]["perc"]
      if (termos[8] != "")
        y9_ = y9 * prioridade.current[8]["perc"]
      if (termos[9] != "")
        y10_ = y10 * prioridade.current[9]["perc"]
      if (termos[10] != "")
        y11_ = y11 * prioridade.current[10]["perc"]
    }

    else if (termos[3] != "") {
      /*y2_ = y2
      y3_ = y3*/
      y4_ = y4 * prioridade.current[3]["perc"] 
      if (termos[4] != "")
        y5_ = y5 * prioridade.current[4]["perc"]
      if (termos[5] != "")
        y6_ = y6 * prioridade.current[5]["perc"]
      if (termos[6] != "")
        y7_ = y7 * prioridade.current[6]["perc"]
      if (termos[7] != "")
        y8_ = y8 * prioridade.current[7]["perc"]
      if (termos[8] != "")
        y9_ = y9 * prioridade.current[8]["perc"]
      if (termos[9] != "")
        y10_ = y10 * prioridade.current[9]["perc"]
      if (termos[10] != "")
        y11_ = y11 * prioridade.current[10]["perc"]
    }
    else if (termos[4] != "") {
      /*y2_ = y2
      y3_ = y3
      y4_ = y4 */
      y5_ = y5 * prioridade.current[4]["perc"]
      if (termos[5] != "")
        y6_ = y6 * prioridade.current[5]["perc"]
      if (termos[6] != "")
        y7_ = y7 * prioridade.current[6]["perc"]
      if (termos[7] != "")
        y8_ = y8 * prioridade.current[7]["perc"]
      if (termos[8] != "")
        y9_ = y9 * prioridade.current[8]["perc"]
      if (termos[9] != "")
        y10_ = y10 * prioridade.current[9]["perc"]
      if (termos[10] != "")
        y11_ = y11 * prioridade.current[10]["perc"]
    }
    else if (termos[5] != "") {
      /*y2_ = y2
      y3_ = y3
      y4_ = y4 
      y5_ = y5*/
      y6_ = y6 * prioridade.current[5]["perc"]
      if (termos[6] != "")
        y7_ = y7 * prioridade.current[6]["perc"]
      if (termos[7] != "")
        y8_ = y8 * prioridade.current[7]["perc"]
      if (termos[8] != "")
        y9_ = y9 * prioridade.current[8]["perc"]
      if (termos[9] != "")
        y10_ = y10 * prioridade.current[9]["perc"]
      if (termos[10] != "")
        y11_ = y11 * prioridade.current[10]["perc"]
    }

    else if (termos[6] != "") {
      /*y2_ = y2
      y3_ = y3
      y4_ = y4 
      y5_ = y5
      y6_ = y6*/
      y7_ = y7 * prioridade.current[6]["perc"]
      if (termos[7] != "")
        y8_ = y8 * prioridade.current[7]["perc"]
      if (termos[8] != "")
        y9_ = y9 * prioridade.current[8]["perc"]
      if (termos[9] != "")
        y10_ = y10 * prioridade.current[9]["perc"]
      if (termos[10] != "")
        y11_ = y11 * prioridade.current[10]["perc"]
    }

    else if (termos[7] != "") {
      /*y2_ = y2
      y3_ = y3
      y4_ = y4 
      y5_ = y5
      y6_ = y6
      y7_ = y7 */
      y8_ = y8 * prioridade.current[7]["perc"]
      if (termos[8] != "")
        y9_ = y9 * prioridade.current[8]["perc"]
      if (termos[9] != "")
        y10_ = y10 * prioridade.current[9]["perc"]
      if (termos[10] != "")
        y11_ = y11 * prioridade.current[10]["perc"]
    }
    
    else if (termos[8] != "") {
      /*y2_ = y2
      y3_ = y3
      y4_ = y4 
      y5_ = y5
      y6_ = y6
      y7_ = y7 
      y8_ = y8*/
      y9_ = y9 * prioridade.current[8]["perc"]
      if (termos[9] != "")
        y10_ = y10 * prioridade.current[9]["perc"]
      if (termos[10] != "")
        y11_ = y11 * prioridade.current[10]["perc"]
    }

    else if (termos[9] != "") {
      /*y2_ = y2
      y3_ = y3
      y4_ = y4 
      y5_ = y5
      y6_ = y6
      y7_ = y7 
      y8_ = y8
      y9_ = y9*/
      y10_ = y10 * prioridade.current[9]["perc"]
      if (termos[10] != "")
        y11_ = y11 * prioridade.current[10]["perc"]
    }
    
    else if (termos[10] != "") {
      y2_ = y2
      y3_ = y3
      y4_ = y4 
      y5_ = y5
      y6_ = y6
      y7_ = y7 
      y8_ = y8
      y9_ = y9
      y10_ = y10
      y11_ = y11
    }
   
    else {
      y2_ = y2
      y3_ = y3
      y4_ = y4
      y5_ = y5
      y6_ = y6
      y7_ = y7
      y8_ = y8
      y9_ = y9
      y10_ = y10
      y11_ = y11
    }

    return {y2_, y3_, y4_, y5_, y6_, y7_, y8_, y9_, y10_, y11_}
  }

 

  function calculo_sintomas(covid, gripe, febre, tosse, diarreia, dor_de_cabeca, resfriado, falta_de_ar, dor_de_garganta, 
    coriza, vomito, y2, y3, y4, y5, y6, y7, y8, y9, y10, y11) {
    let y2_ = 0
    let y3_ = 0
    let y4_ = 0
    let y5_ = 0
    let y6_ = 0
    let y7_ = 0
    let y8_ = 0 
    let y9_ = 0
    let y10_ = 0
    let y11_ = 0

    if (covid) {
      if (gripe)
        y2_ = y2 * media_covid['gripe']
      if (febre)
        y3_ = y3 * media_covid['febre']
      if (tosse)
        y4_ = y4 * media_covid['tosse']
      if (diarreia)
        y5_ = y5 * media_covid['diarreia']
      if (dor_de_cabeca)
        y6_ = y6 * media_covid['dor_de_cabeca']
      if (resfriado)
        y7_ = y7 * media_covid['resfriado']
      if (falta_de_ar)
        y8_ = y8 * media_covid['falta_de_ar']
      if (dor_de_garganta)
        y9_ = y9 * media_covid['dor_de_garganta']
      if (coriza)
        y10_ = y10 * media_covid['coriza']
      if (vomito)
        y11_ = y11 * media_covid['vomito']
    }
        
    else if (gripe) {
      y2_ = y2
      if (febre)
        y3_ = y3 * media_gripe['febre']
      if (tosse)
        y4_ = y4 * media_gripe['tosse']
      if (diarreia)
        y5_ = y5 * media_gripe['diarreia']
      if (dor_de_cabeca)
        y6_ = y6 * media_gripe['dor_de_cabeca']
      if (resfriado)
        y7_ = y7 * media_gripe['resfriado']
      if (falta_de_ar)
        y8_ = y8 * media_gripe['falta_de_ar']
      if (dor_de_garganta)
        y9_ = y9 * media_gripe['dor_de_garganta']
      if (coriza)
        y10_ = y10 * media_gripe['coriza']
      if (vomito)
        y11_ = y11 * media_gripe['vomito']
    }

    else if (febre) {
      y2_ = y2
      y3_ = y3
      if (tosse)
        y4_ = y4 * (media_gripe['tosse'] / media_gripe['febre'])
      if (diarreia)
        y5_ = y5 * (media_gripe['diarreia'] / media_gripe['febre'])
      if (dor_de_cabeca)
        y6_ = y6 * (media_gripe['dor_de_cabeca'] / media_gripe['febre'])
      if (resfriado)
        y7_ = y7 * (media_gripe['resfriado'] / media_gripe['febre'])
      if (falta_de_ar)
        y8_ = y8 * (media_gripe['falta_de_ar'] / media_gripe['febre'])
      if (dor_de_garganta)
        y9_ = y9 * (media_gripe['dor_de_garganta'] / media_gripe['febre'])
      if (coriza)
        y10_ = y10 * (media_gripe['coriza'] / media_gripe['febre'])
      if (vomito)
        y11_ = y11 * (media_gripe['vomito'] / media_gripe['febre'])
    }
    else if (tosse)
    {
      y2_ = y2
      y3_ = y3
      y4_ = y4
      if  (diarreia)
        y5_ = y5 * (media_gripe['diarreia'] / media_gripe['tosse'])
      if  (dor_de_cabeca)
        y6_ = y6 * (media_gripe['dor_de_cabeca'] / media_gripe['tosse'])
      if  (resfriado)
        y7_ = y7 * (media_gripe['resfriado'] / media_gripe['tosse'])
      if  (falta_de_ar)
        y8_ = y8 * (media_gripe['falta_de_ar'] / media_gripe['tosse'])
      if  (dor_de_garganta)
        y9_ = y9 * (media_gripe['dor_de_garganta'] / media_gripe['tosse'])
      if  (coriza)
        y10_ = y10 * (media_gripe['coriza'] / media_gripe['tosse'])
      if  (vomito)
        y11_ = y11 * (media_gripe['vomito'] / media_gripe['tosse'])
    }
    else if (diarreia)
    {
      y2_ = y2
      y3_ = y3
      y4_ = y4
      y5_ = y5
      if (dor_de_cabeca)
        y6_ = y6 * (media_gripe['dor_de_cabeca'] / media_gripe['diarreia'])
      if (resfriado)
        y7_ = y7 * (media_gripe['resfriado'] / media_gripe['diarreia'])
      if (falta_de_ar)
        y8_ = y8 * (media_gripe['falta_de_ar'] / media_gripe['diarreia'])
      if (dor_de_garganta)
        y9_ = y9 * (media_gripe['dor_de_garganta'] / media_gripe['diarreia'])
      if (coriza)
        y10_ = y10 * (media_gripe['coriza'] / media_gripe['diarreia'])
      if (vomito)
        y11_ = y11 * (media_gripe['vomito'] / media_gripe['diarreia'])
    }

    else if (dor_de_cabeca)
    {
      y2_ = y2
      y3_ = y3
      y4_ = y4
      y5_ = y5
      y6_ = y6
      if (resfriado)
        y7_ = y7 * (media_gripe['resfriado'] / media_gripe['dor_de_cabeca'])
      if (falta_de_ar)
        y8_ = y8 * (media_gripe['falta_de_ar'] / media_gripe['dor_de_cabeca'])
      if (dor_de_garganta)
        y9_ = y9 * (media_gripe['dor_de_garganta'] / media_gripe['dor_de_cabeca'])
      if (coriza)
        y10_ = y10 * (media_gripe['coriza'] / media_gripe['dor_de_cabeca'])
      if (vomito)
        y11_ = y11 * (media_gripe['vomito'] / media_gripe['dor_de_cabeca'])
    }

    else if (resfriado)
    {
      y2_ = y2
      y3_ = y3
      y4_ = y4
      y5_ = y5
      y6_ = y6
      y7_ = y7
      if (falta_de_ar)
        y8_ = y8 * (media_gripe['falta_de_ar'] / media_gripe['resfriado'])
      if (dor_de_garganta)
        y9_ = y9 * (media_gripe['dor_de_garganta'] / media_gripe['resfriado'])
      if (coriza)
        y10_ = y10 * (media_gripe['coriza'] / media_gripe['resfriado'])
      if (vomito)
        y11_ = y11 * (media_gripe['vomito'] / media_gripe['resfriado'])
    }
    
    else if (falta_de_ar)
    {
      y2_ = y2
      y3_ = y3
      y4_ = y4
      y5_ = y5
      y6_ = y6
      y7_ = y7
      y8_ = y8
      if (dor_de_garganta)
        y9_ = y9 * (media_gripe['dor_de_garganta'] / media_gripe['falta_de_ar'])
      if (coriza)
        y10_ = y10 * (media_gripe['coriza'] / media_gripe['falta_de_ar'])
      if (vomito)
        y11_ = y11 * (media_gripe['vomito'] / media_gripe['falta_de_ar'])
    }

    else if (dor_de_garganta)
    {
      y2_ = y2
      y3_ = y3
      y4_ = y4
      y5_ = y5
      y6_ = y6
      y7_ = y7
      y8_ = y8
      y9_ = y9
      if (coriza)
        y10_ = y10 * (media_gripe['coriza'] / media_gripe['dor_de_garganta'])
      if (vomito)
        y11_ = y11 * (media_gripe['vomito'] / media_gripe['dor_de_garganta'])
    }
    
    else if (coriza)
    {
      y2_ = y2
      y3_ = y3
      y4_ = y4
      y5_ = y5
      y6_ = y6
      y7_ = y7
      y8_ = y8
      y9_ = y9
      y10_ = y10
      if (vomito)
        y11_ = y11 * (media_gripe['vomito'] / media_gripe['coriza'])
    }
    
    else if (vomito)
    {
      y2_ = y2
      y3_ = y3
      y4_ = y4
      y5_ = y5
      y6_ = y6
      y7_ = y7
      y8_ = y8
      y9_ = y9
      y10_ = y10
      y11_ = y11
    }
   
    else {
      y2_ = y2
      y3_ = y3
      y4_ = y4
      y5_ = y5
      y6_ = y6
      y7_ = y7
      y8_ = y8
      y9_ = y9
      y10_ = y10
      y11_ = y11
    }

    return {y2_, y3_, y4_, y5_, y6_, y7_, y8_, y9_, y10_, y11_}
  }

  const calculateMovingAverage = (data, period) => {
    const dates = Object.keys(data);
    if (dates.length < period) return [];
    let movingAverages = [];
    for (let i = 0; i <= dates.length - period; i++) {
      let sum = 0;
      for (let j = 0; j < period; j++) {
        sum += data[dates[i + j]];
      }
      let average = sum / period;
      movingAverages.push({ data: dates[i + period - 1], total:average });
    }
  
    return movingAverages;
  };



  /*
  const calculateMovingAverage = (data, period) => {
    if (data.length < period) return [];
  
    let movingAverages = [];
    for (let i = 0; i <= data.length - period; i++) {
      let sum = 0;
      for (let j = 0; j < period; j++) {
        sum += data[i + j].total;
      }
      let average = sum / period;
      movingAverages.push({ data: data[i + period - 1].data, total: average });
    }
  
    return movingAverages;
  };*/

  const validarEstrutura = (objeto) => {
    // Regex para validar o formato da data
    const regexData = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
  
    for (let chave in objeto) {
      if (!regexData.test(chave)) {
        console.error(`Chave inválida: ${chave}`);
        return false;
      }
  
      const valor = objeto[chave];
      if (typeof valor !== 'number') {
        console.error(`Valor inválido na chave ${chave}: ${valor}`);
        return false;
      }
    }
  
    return true;
  };

  useEffect(() => {    
    
        if(!iniciou){
          return;
        }
        //console.log("useEffect minIdxDate, maxIdxDate, ocultaCovid, ocultaGripe, ocultaFebre, ocultaTosse...", getHora());
      
        

        /*let exibe0 = !getOcultar(prioridade.current[0]["nome"]) ? prioridade.current[0]["nome"] : "";
        let exibe1 = !getOcultar(prioridade.current[1]["nome"]) ? prioridade.current[1]["nome"] : "";
        let exibe2 = !getOcultar(prioridade.current[2]["nome"]) ? prioridade.current[2]["nome"] : "";
        let exibe3 = !getOcultar(prioridade.current[3]["nome"]) ? prioridade.current[3]["nome"] : "";
        let exibe4 = !getOcultar(prioridade.current[4]["nome"]) ? prioridade.current[4]["nome"] : "";
        let exibe5 = !getOcultar(prioridade.current[5]["nome"]) ? prioridade.current[5]["nome"] : "";
        let exibe6 = !getOcultar(prioridade.current[6]["nome"]) ? prioridade.current[6]["nome"] : "";
        let exibe7 = !getOcultar(prioridade.current[7]["nome"]) ? prioridade.current[7]["nome"] : "";
        let exibe8 = !getOcultar(prioridade.current[8]["nome"]) ? prioridade.current[8]["nome"] : "";
        let exibe9 = !getOcultar(prioridade.current[9]["nome"]) ? prioridade.current[9]["nome"] : "";
        let exibe10 = !getOcultar(prioridade.current[10]["nome"]) ? prioridade.current[10]["nome"] : "";


        atualizaGraficoRelativo([exibe0, exibe1, exibe2, exibe3, exibe4, exibe5, exibe6, exibe7, exibe8, exibe9, exibe10]);*/
 
        //console.log("Atualizando gráficos");
        if(!isAllSelect(municipioSelecionado)){
          carregaDadosMunicipio(cod_ibge);
        } else {
          let siglaEstado = "";
          let codEstado = "";
          for (let index = 0; index < cod_estados.length; index++) {
            const element = cod_estados[index];
            //compare em minusculo
            if(element["NOME"].toLowerCase() === estadoSelecionado.toLowerCase()){
                siglaEstado = element["UF"];
                codEstado = element["COD"];
                codEstado = codEstado.toString();
                break;
            }
          }
        }
        
        /*atualizaGraficoRelativo(ocultaCovid, ocultaGripe, ocultaFebre, ocultaTosse,
          ocultaDiarreia, ocultaDorDeCabeca, ocultaResfriado, ocultaFaltaDeAr, ocultaDorDeGarganta, ocultaCoriza, ocultaVomito);*/
      
     /*atualizaGrafico(ocultaCovid, ocultaGripe, ocultaFebre, ocultaTosse, 
      ocultaDiarreia, ocultaDorDeCabeca, ocultaResfriado, ocultaFaltaDeAr, ocultaDorDeGarganta, ocultaCoriza, ocultaVomito);*/
  }, [minIdxDate, maxIdxDate, ocultaCovid, ocultaGripe, ocultaFebre, ocultaTosse, 
    ocultaDiarreia, ocultaDorDeCabeca, ocultaResfriado, ocultaFaltaDeAr, ocultaDorDeGarganta, ocultaCoriza, ocultaVomito]);

  useEffect(() => {
    if(dadosCovid.current.length > 0 && prioridade.current.length > 0){
      let exibe0 = !getOcultar(prioridade.current[0]["nome"]) ? prioridade.current[0]["nome"] : "";
      let exibe1 = !getOcultar(prioridade.current[1]["nome"]) ? prioridade.current[1]["nome"] : "";
      let exibe2 = !getOcultar(prioridade.current[2]["nome"]) ? prioridade.current[2]["nome"] : "";
      let exibe3 = !getOcultar(prioridade.current[3]["nome"]) ? prioridade.current[3]["nome"] : "";
      let exibe4 = !getOcultar(prioridade.current[4]["nome"]) ? prioridade.current[4]["nome"] : "";
      let exibe5 = !getOcultar(prioridade.current[5]["nome"]) ? prioridade.current[5]["nome"] : "";
      let exibe6 = !getOcultar(prioridade.current[6]["nome"]) ? prioridade.current[6]["nome"] : "";
      let exibe7 = !getOcultar(prioridade.current[7]["nome"]) ? prioridade.current[7]["nome"] : "";
      let exibe8 = !getOcultar(prioridade.current[8]["nome"]) ? prioridade.current[8]["nome"] : "";
      let exibe9 = !getOcultar(prioridade.current[9]["nome"]) ? prioridade.current[9]["nome"] : "";
      let exibe10 = !getOcultar(prioridade.current[10]["nome"]) ? prioridade.current[10]["nome"] : "";

      //atualizaGraficoRelativo([exibe0, exibe1, exibe2, exibe3, exibe4, exibe5, exibe6, exibe7, exibe8, exibe9, exibe10]);
      /*atualizaGraficoRelativo(ocultaCovid, ocultaGripe, ocultaFebre, ocultaTosse,
        ocultaDiarreia, ocultaDorDeCabeca, ocultaResfriado, ocultaFaltaDeAr, ocultaDorDeGarganta, ocultaCoriza, ocultaVomito);*/
    }
   /* atualizaGrafico(ocultaCovid, ocultaGripe, ocultaFebre, ocultaTosse, 
      ocultaDiarreia, ocultaDorDeCabeca, ocultaResfriado, ocultaFaltaDeAr, ocultaDorDeGarganta, ocultaCoriza, ocultaVomito);*/
  
    if(isAllSelect(estadoSelecionado)){
      setEstadoSelecionado(t("dashboard.todos"));
    }

    if(isAllSelect(municipioSelecionado)){
      setMunicipioSelecionado(t("dashboard.todos"));
    }


    cidades_labels[0] = {label:t("dashboard.todos")};

    if(listaMunicipios.length === 1){
      setListaMunicipios(getCidades());
    }

    defaultPropsMunicipio = {
      options: cidades_labels,
      getOptionLabel: (option) => option.label,
    };

    let newSelected = [];

    if(selectedVar.includes(t("dashboard.variaveisGoogle.coriza", { lng: "pt-BR" })) || selectedVar.includes(t("dashboard.variaveisGoogle.coriza", { lng: "en-US" }))){
      newSelected.push(t("dashboard.variaveisGoogle.coriza"));
    }

    if(selectedVar.includes(t("dashboard.variaveisGoogle.covid", { lng: "pt-BR" })) || selectedVar.includes(t("dashboard.variaveisGoogle.covid", { lng: "en-US" }))){
      newSelected.push(t("dashboard.variaveisGoogle.covid"));
    }

    if(selectedVar.includes(t("dashboard.variaveisGoogle.diarreia", { lng: "pt-BR" })) || selectedVar.includes(t("dashboard.variaveisGoogle.diarreia", { lng: "en-US" }))){
      newSelected.push(t("dashboard.variaveisGoogle.diarreia"));
    }

    if(selectedVar.includes(t("dashboard.variaveisGoogle.dor_de_cabeca", { lng: "pt-BR" })) || selectedVar.includes(t("dashboard.variaveisGoogle.dor_de_cabeca", { lng: "en-US" }))){
      newSelected.push(t("dashboard.variaveisGoogle.dor_de_cabeca"));
    }

    if(selectedVar.includes(t("dashboard.variaveisGoogle.dor_de_garganta", { lng: "pt-BR" })) || selectedVar.includes(t("dashboard.variaveisGoogle.dor_de_garganta", { lng: "en-US" }))){
      newSelected.push(t("dashboard.variaveisGoogle.dor_de_garganta"));
    }

    if(selectedVar.includes(t("dashboard.variaveisGoogle.falta_de_ar", { lng: "pt-BR" })) || selectedVar.includes(t("dashboard.variaveisGoogle.falta_de_ar", { lng: "en-US" }))){
      newSelected.push(t("dashboard.variaveisGoogle.falta_de_ar"));
    }

    if(selectedVar.includes(t("dashboard.variaveisGoogle.febre", { lng: "pt-BR" })) || selectedVar.includes(t("dashboard.variaveisGoogle.febre", { lng: "en-US" }))){
      newSelected.push(t("dashboard.variaveisGoogle.febre"));
    }

    if(selectedVar.includes(t("dashboard.variaveisGoogle.gripe", { lng: "pt-BR" })) || selectedVar.includes(t("dashboard.variaveisGoogle.gripe", { lng: "en-US" }))){
      newSelected.push(t("dashboard.variaveisGoogle.gripe"));
    }

    if(selectedVar.includes(t("dashboard.variaveisGoogle.resfriado", { lng: "pt-BR" })) || selectedVar.includes(t("dashboard.variaveisGoogle.resfriado", { lng: "en-US" }))){
      newSelected.push(t("dashboard.variaveisGoogle.resfriado"));
    }

    if(selectedVar.includes(t("dashboard.variaveisGoogle.tosse", { lng: "pt-BR" })) || selectedVar.includes(t("dashboard.variaveisGoogle.tosse", { lng: "en-US" }))){
      newSelected.push(t("dashboard.variaveisGoogle.tosse"));
    }

    if(selectedVar.includes(t("dashboard.variaveisGoogle.vomito", { lng: "pt-BR" })) || selectedVar.includes(t("dashboard.variaveisGoogle.vomito", { lng: "en-US" }))){
      newSelected.push(t("dashboard.variaveisGoogle.vomito"));
    }

    setListaVariavelMediaMovel([
      {"sinal": "1", "nome": t("dashboard.variaveisGoogle.coriza")},
      {"sinal": "2", "nome": t("dashboard.variaveisGoogle.covid")},
      {"sinal": "3", "nome": t("dashboard.variaveisGoogle.diarreia")},
      {"sinal": "4", "nome": t("dashboard.variaveisGoogle.dor_de_cabeca")},
      {"sinal": "5", "nome": t("dashboard.variaveisGoogle.dor_de_garganta")},
      {"sinal": "6", "nome": t("dashboard.variaveisGoogle.falta_de_ar")},
      {"sinal": "7", "nome": t("dashboard.variaveisGoogle.febre")},
      {"sinal": "8", "nome": t("dashboard.variaveisGoogle.gripe")},
      {"sinal": "9", "nome": t("dashboard.variaveisGoogle.resfriado")},
      {"sinal": "10", "nome": t("dashboard.variaveisGoogle.tosse")},
      {"sinal": "11", "nome": t("dashboard.variaveisGoogle.vomito")},
    ]);

    setlistaMediaMovel([
      {"sinal": "1", "nome": "1 " + t("dashboard.semana")},
      {"sinal": "2", "nome": "2 " + t("dashboard.semanas")},
      {"sinal": "3", "nome": "3 " + t("dashboard.semanas")},
      {"sinal": "4", "nome": "4 " + t("dashboard.semanas")},
    ]);

    setSelectedVar(newSelected);
  
  }, [language]);

  const atualizaMediaMovel = () => {
    dadosCovidMediaMovel.current = dadosCovid.current;
    dadosDiarreiaMediaMovel.current = dadosDiarreia.current;
    dadosDorDeCabecaMediaMovel.current = dadosDorDeCabeca.current;
    dadosDorDeGargantaMediaMovel.current = dadosDorDeGarganta.current;
    dadosFaltaDeArMediaMovel.current = dadosFaltaDeAr.current;
    dadosFebreMediaMovel.current = dadosFebre.current;
    dadosGripeMediaMovel.current = dadosGripe.current;
    dadosResfriadoMediaMovel.current = dadosResfriado.current;
    dadosTosseMediaMovel.current = dadosTosse.current;
    dadosVomitoMediaMovel.current = dadosVomito.current;
    dadosGripalMediaMovel.current = dadosGripal.current;
    dadosCorizaMediaMovel.current = dadosCoriza.current;
    
    //crie uma variavel temporaria para converter mediaMovelSelecionada para int
    let mediaMovelSelecionadaTemp = parseInt(mediaMovelSelecionada);

    dadosCovidMediaMovel.current = calculateMovingAverage(dadosCovidMediaMovel.current, mediaMovelSelecionadaTemp);
    dadosDiarreiaMediaMovel.current = calculateMovingAverage(dadosDiarreiaMediaMovel.current, mediaMovelSelecionadaTemp);
    dadosDorDeCabecaMediaMovel.current = calculateMovingAverage(dadosDorDeCabecaMediaMovel.current, mediaMovelSelecionadaTemp);
    dadosDorDeGargantaMediaMovel.current = calculateMovingAverage(dadosDorDeGargantaMediaMovel.current, mediaMovelSelecionadaTemp);
    dadosFaltaDeArMediaMovel.current = calculateMovingAverage(dadosFaltaDeArMediaMovel.current, mediaMovelSelecionadaTemp);
    dadosFebreMediaMovel.current = calculateMovingAverage(dadosFebreMediaMovel.current, mediaMovelSelecionadaTemp);
    dadosGripeMediaMovel.current = calculateMovingAverage(dadosGripeMediaMovel.current, mediaMovelSelecionadaTemp);
    dadosResfriadoMediaMovel.current = calculateMovingAverage(dadosResfriadoMediaMovel.current, mediaMovelSelecionadaTemp);
    dadosTosseMediaMovel.current = calculateMovingAverage(dadosTosseMediaMovel.current, mediaMovelSelecionadaTemp);
    dadosVomitoMediaMovel.current = calculateMovingAverage(dadosVomitoMediaMovel.current, mediaMovelSelecionadaTemp);
    dadosCorizaMediaMovel.current = calculateMovingAverage(dadosCorizaMediaMovel.current, mediaMovelSelecionadaTemp);

    let maiorValor = 0;

    for (let key = 0; key < dadosCovidMediaMovel.current.length; key++) {
      if(dadosCovidMediaMovel.current[key]["data"] >= datas[minIdxDate] && dadosCovidMediaMovel.current[key]["data"] <= datas[maxIdxDate]){
        switch (variavelMediaMovelSelecionada) {
          case "1":
            if(dadosCorizaMediaMovel.current[key]["total"] > maiorValor)
              maiorValor = dadosCorizaMediaMovel.current[key]["total"];
            break;
          case "2":
            if(dadosCovidMediaMovel.current[key]["total"] > maiorValor)
              maiorValor = dadosCovidMediaMovel.current[key]["total"];
            break;
          case "3":
            if(dadosDiarreiaMediaMovel.current[key]["total"] > maiorValor)
              maiorValor = dadosDiarreiaMediaMovel.current[key]["total"];
            break;
          case "4":
            if(dadosDorDeCabecaMediaMovel.current[key]["total"] > maiorValor)
              maiorValor = dadosDorDeCabecaMediaMovel.current[key]["total"];
            break;
          case "5":
            if(dadosDorDeGargantaMediaMovel.current[key]["total"] > maiorValor)
              maiorValor = dadosDorDeGargantaMediaMovel.current[key]["total"];
            break;
          case "6":
            if(dadosFaltaDeArMediaMovel.current[key]["total"] > maiorValor)
              maiorValor = dadosFaltaDeArMediaMovel.current[key]["total"];
            break;
          case "7":
            if(dadosFebreMediaMovel.current[key]["total"] > maiorValor)
              maiorValor = dadosFebreMediaMovel.current[key]["total"];
            break;
          case "8":
            if(dadosGripeMediaMovel.current[key]["total"] > maiorValor)
              maiorValor = dadosGripeMediaMovel.current[key]["total"];
            break;
          case "9":
            if(dadosResfriadoMediaMovel.current[key]["total"] > maiorValor)
              maiorValor = dadosResfriadoMediaMovel.current[key]["total"];
            break;
          case "10":
            if(dadosTosseMediaMovel.current[key]["total"] > maiorValor)
              maiorValor = dadosTosseMediaMovel.current[key]["total"];
            break;
          case "11":
            if(dadosVomitoMediaMovel.current[key]["total"] > maiorValor)
              maiorValor = dadosVomitoMediaMovel.current[key]["total"];  
            break;
          default:
            break;
        }  
      }       
    };
    
    let multiplicador = maiorValor == 0 ? 1 : 100 / maiorValor;

    //aplique o multiplicador para todos os valores
    for (let key = 0; key < dadosCorizaMediaMovel.current.length; key++) {
      dadosCorizaMediaMovel.current[key]['total'] = dadosCorizaMediaMovel.current[key]['total'] * multiplicador;
      dadosCovidMediaMovel.current[key]['total'] = dadosCovidMediaMovel.current[key]['total'] * multiplicador;
      dadosDiarreiaMediaMovel.current[key]['total'] = dadosDiarreiaMediaMovel.current[key]['total'] * multiplicador;
      dadosDorDeCabecaMediaMovel.current[key]['total'] = dadosDorDeCabecaMediaMovel.current[key]['total'] * multiplicador;
      dadosDorDeGargantaMediaMovel.current[key]['total'] = dadosDorDeGargantaMediaMovel.current[key]['total'] * multiplicador;
      dadosFaltaDeArMediaMovel.current[key]['total'] = dadosFaltaDeArMediaMovel.current[key]['total'] * multiplicador;
      dadosFebreMediaMovel.current[key]['total'] = dadosFebreMediaMovel.current[key]['total'] * multiplicador;
      dadosGripeMediaMovel.current[key]['total'] = dadosGripeMediaMovel.current[key]['total'] * multiplicador;
      dadosResfriadoMediaMovel.current[key]['total'] = dadosResfriadoMediaMovel.current[key]['total'] * multiplicador;
      dadosTosseMediaMovel.current[key]['total'] = dadosTosseMediaMovel.current[key]['total'] * multiplicador;
      dadosVomitoMediaMovel.current[key]['total'] = dadosVomitoMediaMovel.current[key]['total'] * multiplicador;
    };

    //pegando o ultimo termo
    if(dadosCovidMediaMovel.current.length > 0){
      setUltimoValorCovidMM(dadosCovidMediaMovel.current[dadosCovidMediaMovel.current.length - 1]["total"]);
      setUltimoValorCorizaMM(dadosCorizaMediaMovel.current[dadosCorizaMediaMovel.current.length - 1]["total"]);
      setUltimoValorDiarreiaMM(dadosDiarreiaMediaMovel.current[dadosDiarreiaMediaMovel.current.length - 1]["total"]);
      setUltimoValorDorDeCabecaMM(dadosDorDeCabecaMediaMovel.current[dadosDorDeCabecaMediaMovel.current.length - 1]["total"]);
      setUltimoValorDorDeGargantaMM(dadosDorDeGargantaMediaMovel.current[dadosDorDeGargantaMediaMovel.current.length - 1]["total"]);
      setUltimoValorFaltaDeArMM(dadosFaltaDeArMediaMovel.current[dadosFaltaDeArMediaMovel.current.length - 1]["total"]);
      setUltimoValorFebreMM(dadosFebreMediaMovel.current[dadosFebreMediaMovel.current.length - 1]["total"]);
      setUltimoValorGripeMM(dadosGripeMediaMovel.current[dadosGripeMediaMovel.current.length - 1]["total"]);
      setUltimoValorResfriadoMM(dadosResfriadoMediaMovel.current[dadosResfriadoMediaMovel.current.length - 1]["total"]);
      setUltimoValorTosseMM(dadosTosseMediaMovel.current[dadosTosseMediaMovel.current.length - 1]["total"]);
      setUltimoValorVomitoMM(dadosVomitoMediaMovel.current[dadosVomitoMediaMovel.current.length - 1]["total"]);
      //setUltimoValorAPS(dadosGripalMediaMovel.current[dadosGripalMediaMovel.current.length - 1]["total"]);
    }

    dadosCorizaMediaMovel.current = Object.fromEntries(
      dadosCorizaMediaMovel.current.map(({data, total}) => [data, total])
    );

    dadosCovidMediaMovel.current = Object.fromEntries(
      dadosCovidMediaMovel.current.map(({data, total}) => [data, total])
    );

    dadosDiarreiaMediaMovel.current = Object.fromEntries(
      dadosDiarreiaMediaMovel.current.map(({data, total}) => [data, total])
    );

    dadosDorDeCabecaMediaMovel.current = Object.fromEntries(
      dadosDorDeCabecaMediaMovel.current.map(({data, total}) => [data, total])
    );

    dadosDorDeGargantaMediaMovel.current = Object.fromEntries(
      dadosDorDeGargantaMediaMovel.current.map(({data, total}) => [data, total])
    );

    dadosFaltaDeArMediaMovel.current = Object.fromEntries(
      dadosFaltaDeArMediaMovel.current.map(({data, total}) => [data, total])
    );

    dadosFebreMediaMovel.current = Object.fromEntries(
      dadosFebreMediaMovel.current.map(({data, total}) => [data, total])
    );

    dadosGripeMediaMovel.current = Object.fromEntries(
      dadosGripeMediaMovel.current.map(({data, total}) => [data, total])
    );

    dadosResfriadoMediaMovel.current = Object.fromEntries(
      dadosResfriadoMediaMovel.current.map(({data, total}) => [data, total])
    );

    dadosTosseMediaMovel.current = Object.fromEntries(
      dadosTosseMediaMovel.current.map(({data, total}) => [data, total])
    );

    dadosVomitoMediaMovel.current = Object.fromEntries(
      dadosVomitoMediaMovel.current.map(({data, total}) => [data, total])
    );




    //console.log(getDadosMediaGraficoTodos(t("dashboard.graficos.titulo_atendimento_gripais"), dadosGripalMediaMovel.current, t("dashboard.variaveisGoogle.coriza"), dadosCorizaMediaMovel.current, t("dashboard.variaveisGoogle.covid"), dadosCovidMediaMovel.current, t("dashboard.variaveisGoogle.diarreia"), dadosDiarreiaMediaMovel.current, t("dashboard.variaveisGoogle.dor_de_cabeca"), dadosDorDeCabecaMediaMovel.current, t("dashboard.variaveisGoogle.dor_de_garganta"), dadosDorDeGargantaMediaMovel.current, t("dashboard.variaveisGoogle.falta_de_ar"), dadosFaltaDeArMediaMovel.current, t("dashboard.variaveisGoogle.febre"), dadosFebreMediaMovel.current, t("dashboard.variaveisGoogle.gripe"), dadosGripeMediaMovel.current, t("dashboard.variaveisGoogle.resfriado"), dadosResfriadoMediaMovel.current, t("dashboard.variaveisGoogle.tosse"), dadosTosseMediaMovel.current, t("dashboard.variaveisGoogle.vomito"), dadosVomitoMediaMovel.current, false));

    setDadosMediaAtendimentoTodos(
      getDadosMediaGraficoTodos(t("dashboard.graficos.titulo_atendimento_gripais"), dadosGripalMediaMovel.current, t("dashboard.variaveisGoogle.coriza"), dadosCorizaMediaMovel.current, t("dashboard.variaveisGoogle.covid"), dadosCovidMediaMovel.current, t("dashboard.variaveisGoogle.diarreia"), dadosDiarreiaMediaMovel.current, t("dashboard.variaveisGoogle.dor_de_cabeca"), dadosDorDeCabecaMediaMovel.current, t("dashboard.variaveisGoogle.dor_de_garganta"), dadosDorDeGargantaMediaMovel.current, t("dashboard.variaveisGoogle.falta_de_ar"), dadosFaltaDeArMediaMovel.current, t("dashboard.variaveisGoogle.febre"), dadosFebreMediaMovel.current, t("dashboard.variaveisGoogle.gripe"), dadosGripeMediaMovel.current, t("dashboard.variaveisGoogle.resfriado"), dadosResfriadoMediaMovel.current, t("dashboard.variaveisGoogle.tosse"), dadosTosseMediaMovel.current, t("dashboard.variaveisGoogle.vomito"), dadosVomitoMediaMovel.current, false)
    );
  }

  const carregaDadosMunicipio = (co_ibge) => {
    //console.log("Carrega dados municipio * ", co_ibge, getHora());
    let tempDatas = [];

    let co_ibge_estado = co_ibge.toString().substring(0,2);

    //let url_prioridade = isAllSelect(co_ibge) ? "Dados/google_trends/prioridade_todos.json" : "Dados/google_trends/estados/prioridade_" + co_ibge_estado + ".json";
    let url_prioridade = servidor +"/api" + (isAllSelect(co_ibge.toString()) ? "/webbased/prioridade" : "/webbased/prioridade/" + co_ibge_estado);

    
    //console.log("-Carrega dados municipio ** ", co_ibge, getHora());
    fetch(url_prioridade, {
      headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + _logado
      }
    })
    .then(response => {
      if (response.status === 401 || response.status === 404) {
        setLogado(null);    
        window.location.href = "/";
      }
      return response.json();
    })
    .then(function (myJson_) {
      prioridade.current = myJson_;
      
      //console.log("Carrega dados municipio ** ", co_ibge, getHora());

      //console.log("url: ", url_prioridade, "Prioridade", prioridade.current);
     
      let url_dados = servidor + "/api/";
      if(co_ibge.length === 2){
        //url_dados = "Dados/google_trends/estados/dados_" + co_ibge + ".json";
        url_dados += "webbased/dado/estado/" + co_ibge;
      } else{
        url_dados += (isAllSelect(co_ibge) ? "webbased/dado/pais" : "webbased/dado/municipio/" + co_ibge);
      }

      
      //console.log("-Carrega dados municipio *** ", co_ibge, getHora());
      fetch(url_dados
                , {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + _logado
                    }
                }
            )
                .then(response => {
                  if (response.status === 401 || response.status === 404 ) {
                    setLogado(null);    
                    window.location.href = "/";
                  }
                  return response.json();
                })
                .then(function (myJson) {

                  //console.log("Carrega dados municipio", co_ibge_estado, co_ibge);
                  
                  //console.log("Carrega dados municipio *** ", co_ibge, getHora());

                  dadosCoriza.current = [];
                  dadosCovid.current = [];
                  dadosDiarreia.current = [];
                  dadosDorDeCabeca.current = [];
                  dadosDorDeGarganta.current = [];
                  dadosFaltaDeAr.current = [];
                  dadosFebre.current = [];
                  dadosGripe.current = [];
                  dadosResfriado.current = [];
                  dadosTosse.current = [];
                  dadosVomito.current = [];
                  dadosGripal.current = [];
            
                  dadosCorizaMediaMovel.current = [];
                  dadosCovidMediaMovel.current = [];
                  dadosDiarreiaMediaMovel.current = [];
                  dadosDorDeCabecaMediaMovel.current = [];
                  dadosDorDeGargantaMediaMovel.current = [];
                  dadosFaltaDeArMediaMovel.current = [];
                  dadosFebreMediaMovel.current = [];
                  dadosGripeMediaMovel.current = [];
                  dadosResfriadoMediaMovel.current = [];
                  dadosTosseMediaMovel.current = [];
                  dadosVomitoMediaMovel.current = [];
                  dadosGripalMediaMovel.current = [];

                  //console.log(myJson);
                  
                  myJson.atendimentos.sort(compararPorData);

                    let tempSemanas = [];
                    for(let i = 0; i < myJson["atendimentos"].length; i++){
                      const element = myJson["atendimentos"][i];

                      element["data"] = element["data"];
                      tempDatas.push(element["data"]);

                      tempSemanas.push((element["semana"]));

                      //console.log(element["data"]);

                      var obj = {};
                      obj['data'] = element["data"];
                      obj['total'] = element["t_g_coriza"];
                      dadosCoriza.current.push(obj);
                      dadosCorizaMediaMovel.current.push(obj);

                      var obj2 = {};
                      obj2['data'] = element["data"];
                      obj2['total'] = element["t_g_covid"];
                      dadosCovid.current.push(obj2);
                      dadosCovidMediaMovel.current.push(obj2);

                      var obj3 = {};
                      obj3['data'] = element["data"];
                      obj3['total'] = element["t_g_diarreia"];
                      dadosDiarreia.current.push(obj3);
                      dadosDiarreiaMediaMovel.current.push(obj3);

                      var obj4 = {};
                      obj4['data'] = element["data"];
                      obj4['total'] = element["t_g_dor_de_cabeca"];
                      dadosDorDeCabeca.current.push(obj4);
                      dadosDorDeCabecaMediaMovel.current.push(obj4);

                      var obj5 = {};
                      obj5['data'] = element["data"];
                      obj5['total'] = element["t_g_dor_de_garganta"];
                      dadosDorDeGarganta.current.push(obj5);
                      dadosDorDeGargantaMediaMovel.current.push(obj5);

                      var obj6 = {};
                      obj6['data'] = element["data"];
                      obj6['total'] = element["t_g_falta_de_ar"];
                      dadosFaltaDeAr.current.push(obj6);
                      dadosFaltaDeArMediaMovel.current.push(obj6);

                      var obj7 = {};
                      obj7['data'] = element["data"];
                      obj7['total'] = element["t_g_febre"];
                      dadosFebre.current.push(obj7);
                      dadosFebreMediaMovel.current.push(obj7);

                      var obj8 = {};
                      obj8['data'] = element["data"];
                      obj8['total'] = element["t_g_gripe"];
                      dadosGripe.current.push(obj8);
                      dadosGripeMediaMovel.current.push(obj8);

                      var obj9 = {};
                      obj9['data'] = element["data"];
                      obj9['total'] = element["t_g_resfriado"];
                      dadosResfriado.current.push(obj9);
                      dadosResfriadoMediaMovel.current.push(obj9);

                      var obj10 = {};
                      obj10['data'] = element["data"];
                      obj10['total'] = element["t_g_tosse"];
                      dadosTosse.current.push(obj10);
                      dadosTosseMediaMovel.current.push(obj10);
                      

                      var obj11 = {};
                      obj11['data'] = element["data"];
                      obj11['total'] = element["t_g_vomito"];
                      dadosVomito.current.push(obj11);
                      dadosVomitoMediaMovel.current.push(obj11);
                      

                      var obj12 = {};
                      obj12['data'] = element["data"];
                      obj12['total'] = element["total_gripal"];
                      dadosGripal.current.push(obj12);
                      dadosGripalMediaMovel.current.push(obj12);
                       
                    }

                    //setDatas(tempDatas);

                    /*
                    //converte datas para semanas
                    let tempSemanas = [];
                    for (let index = 0; index < tempDatas.length; index++) {
                      const element = tempDatas[index];
                      tempSemanas.push(moment(element).isoWeek());
                    }*/
                    setSemanas(tempSemanas);
                    /*
                    let tempInicioSemana = [];
                    let tempFimSemana = [];
                    for (let index = 0; index < tempDatas.length; index++) {
                      const element = tempDatas[index];
                      tempInicioSemana.push(moment(element).startOf('isoWeek').format('YYYY-MM-DD'));
                      tempFimSemana.push(moment(element).endOf('isoWeek').format('YYYY-MM-DD'));
                    }

                    setInicioSemanas(tempInicioSemana);
                    setFimSemanas(tempFimSemana);
                    */

                    dadosCoriza.current = Object.fromEntries(
                      dadosCoriza.current.map(({data, total}) => [data, total])
                    );

                    dadosCovid.current = Object.fromEntries(
                      dadosCovid.current.map(({data, total}) => [data, total])
                    );

                    dadosDiarreia.current = Object.fromEntries(
                      dadosDiarreia.current.map(({data, total}) => [data, total])
                    );

                    dadosDorDeCabeca.current = Object.fromEntries(
                      dadosDorDeCabeca.current.map(({data, total}) => [data, total])
                    );

                    dadosDorDeGarganta.current = Object.fromEntries(
                      dadosDorDeGarganta.current.map(({data, total}) => [data, total])
                    );

                    dadosFaltaDeAr.current = Object.fromEntries(
                      dadosFaltaDeAr.current.map(({data, total}) => [data, total])
                    );

                    dadosFebre.current = Object.fromEntries(
                      dadosFebre.current.map(({data, total}) => [data, total])
                    );

                    dadosGripe.current = Object.fromEntries(
                      dadosGripe.current.map(({data, total}) => [data, total])
                    );

                    dadosResfriado.current = Object.fromEntries(
                      dadosResfriado.current.map(({data, total}) => [data, total])
                    );

                    dadosTosse.current = Object.fromEntries(
                      dadosTosse.current.map(({data, total}) => [data, total])
                    );

                    dadosVomito.current = Object.fromEntries(
                      dadosVomito.current.map(({data, total}) => [data, total])
                    );

                    dadosGripal.current = Object.fromEntries(
                      dadosGripal.current.map(({data, total}) => [data, total])
                    );                    

                    let exibe0 = !getOcultar(prioridade.current[0]["nome"]) ? prioridade.current[0]["nome"] : "";
                    let exibe1 = !getOcultar(prioridade.current[1]["nome"]) ? prioridade.current[1]["nome"] : "";
                    let exibe2 = !getOcultar(prioridade.current[2]["nome"]) ? prioridade.current[2]["nome"] : "";
                    let exibe3 = !getOcultar(prioridade.current[3]["nome"]) ? prioridade.current[3]["nome"] : "";
                    let exibe4 = !getOcultar(prioridade.current[4]["nome"]) ? prioridade.current[4]["nome"] : "";
                    let exibe5 = !getOcultar(prioridade.current[5]["nome"]) ? prioridade.current[5]["nome"] : "";
                    let exibe6 = !getOcultar(prioridade.current[6]["nome"]) ? prioridade.current[6]["nome"] : "";
                    let exibe7 = !getOcultar(prioridade.current[7]["nome"]) ? prioridade.current[7]["nome"] : "";
                    let exibe8 = !getOcultar(prioridade.current[8]["nome"]) ? prioridade.current[8]["nome"] : "";
                    let exibe9 = !getOcultar(prioridade.current[9]["nome"]) ? prioridade.current[9]["nome"] : "";
                    let exibe10 = !getOcultar(prioridade.current[10]["nome"]) ? prioridade.current[10]["nome"] : "";

                    //console.log(prioridade[0]["nome"], prioridade[1]["nome"], prioridade[2]["nome"], prioridade[3]["nome"], prioridade[4]["nome"], prioridade[5]["nome"], prioridade[6]["nome"], prioridade[7]["nome"], prioridade[8]["nome"], prioridade[9]["nome"], prioridade[10]["nome"])
                    //console.log(minIdxDate, maxIdxDate, tempDatas.length, tempDatas[0], tempDatas[tempDatas.length - 1], tempDatas);
                    //console.log(exibe0, exibe1, exibe2, exibe3, exibe4, exibe5, exibe6, exibe7, exibe8, exibe9, exibe10);

                    //console.log(dadosCoriza.current, dadosCovid.current, dadosDiarreia.current, dadosDorDeCabeca.current, dadosDorDeGarganta.current, dadosFaltaDeAr.current, dadosFebre.current, dadosGripe.current, dadosResfriado.current, dadosTosse.current, dadosVomito.current, dadosGripal.current);

                    //console.log("atualizaGraficoRelativo");
                    //console.log("chamada atualizaGraficoRelativo carregaDadosMunicipio", municipioSelecionado, [exibe0, exibe1, exibe2, exibe3, exibe4, exibe5, exibe6, exibe7, exibe8, exibe9, exibe10], getHora());
                    atualizaGraficoRelativo([exibe0, exibe1, exibe2, exibe3, exibe4, exibe5, exibe6, exibe7, exibe8, exibe9, exibe10], tempDatas);
                    
                    atualizaMediaMovel();
                  });
            });
  }

  const [iniciou, setIniciou] = useState(false);

  const comparaDataInicio = (data1, data2) => {        
    if(data1 === null || data2 === null)
        return false;
    return data1 >= data2;
  }

  const getIdxDataInicio = (datas_local) => {
    var idx = 0;
    for (let idx_data = 0; idx_data < datas_local.length; idx_data++) {
        if (comparaDataInicio(new Date(datas_local[idx_data]), dataInicial.current)) {
            idx = idx_data;
            break;
        }
    }
    return idx;
  }

  const getLastYear = (dt) => {
    let dt_local = new Date(dt);
    dt_local.setFullYear(dt_local.getFullYear() - Number(1));
    return dt_local;
}

const calculateWeekStartEnd = (week, year) => {
  const firstDayOfYear = new Date(year, 0, 1);
  const firstWeekStart = new Date(firstDayOfYear);
  firstWeekStart.setDate(firstDayOfYear.getDate() - firstDayOfYear.getDay() + 1);
  const weekStartDate = new Date(firstWeekStart);
  weekStartDate.setDate(firstWeekStart.getDate() + (week - 1) * 7);
  const weekEndDate = new Date(weekStartDate);
  weekEndDate.setDate(weekStartDate.getDate() + 6);

  return [weekStartDate.toLocaleDateString(), weekEndDate.toLocaleDateString()];
};

  function getOcultar(termo){
    if(termo === "covid")
      return ocultaCovid;
    if(termo === "gripe")
      return ocultaGripe;
    if(termo === "febre")
      return ocultaFebre;
    if(termo === "tosse")
      return ocultaTosse;
    if(termo === "diarreia")
      return ocultaDiarreia;
    if(termo === "dor_de_cabeca")
      return ocultaDorDeCabeca;
    if(termo === "resfriado")
      return ocultaResfriado;
    if(termo === "falta_de_ar")
      return ocultaFaltaDeAr;
    if(termo === "dor_de_garganta")
      return ocultaDorDeGarganta;
    if(termo === "coriza")
      return ocultaCoriza;
    if(termo === "vomito")
      return ocultaVomito;
  };

  function getOcultarTemp(termo){
    if(termo === "covid")
      return ocultaCovid;
    if(termo === "gripe")
      return ocultaGripe;
    if(termo === "febre")
      return ocultaFebre;
    if(termo === "tosse")
      return ocultaTosse;
    if(termo === "diarreia")
      return ocultaDiarreia;
    if(termo === "dor_de_cabeca")
      return ocultaDorDeCabeca;
    if(termo === "resfriado")
      return ocultaResfriado;
    if(termo === "falta_de_ar")
      return ocultaFaltaDeAr;
    if(termo === "dor_de_garganta")
      return ocultaDorDeGarganta;
    if(termo === "coriza")
      return ocultaCoriza;
    if(termo === "vomito")
      return ocultaVomito;
  };

  function getDados(idx_termo){
    if(getIndiceTermo("covid", prioridade.current) === idx_termo){
      //console.log(idx_termo, "covid");
      return dadosCovid.current;
    }
    if(getIndiceTermo("gripe", prioridade.current) === idx_termo){
      //console.log(idx_termo, "gripe");
      return dadosGripe.current;
    }
    if(getIndiceTermo("febre", prioridade.current) === idx_termo){
      //console.log(idx_termo, "febre");
      return dadosFebre.current;
    }
    if(getIndiceTermo("tosse", prioridade.current) === idx_termo){
      //console.log(idx_termo, "tosse");
      return dadosTosse.current;
    }
    if(getIndiceTermo("diarreia", prioridade.current) === idx_termo){
      //console.log(idx_termo, "diarreia");
      return dadosDiarreia.current;
    }
    if(getIndiceTermo("dor_de_cabeca", prioridade.current) === idx_termo){
      //console.log(idx_termo, "dor_de_cabeca");
      return dadosDorDeCabeca.current;
    }
    if(getIndiceTermo("resfriado", prioridade.current) === idx_termo){
      //console.log(idx_termo, "resfriado");
      return dadosResfriado.current;
    }
    if(getIndiceTermo("falta_de_ar", prioridade.current) === idx_termo){
      //console.log(idx_termo, "falta_de_ar");
      return dadosFaltaDeAr.current;
    }
    if(getIndiceTermo("dor_de_garganta", prioridade.current) === idx_termo){
      //console.log(idx_termo, "dor_de_garganta");
      return dadosDorDeGarganta.current;
    }
    if(getIndiceTermo("coriza", prioridade.current) === idx_termo){
      //console.log(idx_termo, "coriza");
      return dadosCoriza.current;
    }
    if(getIndiceTermo("vomito", prioridade.current) === idx_termo){
      //console.log(idx_termo, "vomito");
      return dadosVomito.current;
    }
  };

  function getIndiceTermo (termo, termos){
    for (let index = 0; index < termos.length; index++) {
      const element = termos[index];
      if(element["nome"] === termo)
        return index;
    }
  };
   
  useEffect(() => {
    if(semanas.length > 0 && prioridade.length > 0){
      let dtInicial = datas[datas.length -1] ;
      dataInicial.current = getLastYear(dtInicial);

      let idxDataInicio = getIdxDataInicio(datas);
      let idxDataSelecionada = datas.length - 1;
      
      setMaxDateRangeInicial(inicioSemanas[idxDataSelecionada]);
      setMaxDateRangeFinal(fimSemanas[idxDataSelecionada]);
      
      setInicioSemanaSelecionada(inicioSemanas[idxDataSelecionada]);
      setFimSemanaSelecionada(fimSemanas[idxDataSelecionada]);
      setInicioSemanaSelecionadaRange(semanas[idxDataInicio]);
      setFimSemanaSelecionadaRange(semanas[idxDataSelecionada]);

      /*let exibe0 = !getOcultar(prioridade[0]["nome"]) ? prioridade[0]["nome"] : "";
      let exibe1 = !getOcultar(prioridade[1]["nome"]) ? prioridade[1]["nome"] : "";
      let exibe2 = !getOcultar(prioridade[2]["nome"]) ? prioridade[2]["nome"] : "";
      let exibe3 = !getOcultar(prioridade[3]["nome"]) ? prioridade[3]["nome"] : "";
      let exibe4 = !getOcultar(prioridade[4]["nome"]) ? prioridade[4]["nome"] : "";
      let exibe5 = !getOcultar(prioridade[5]["nome"]) ? prioridade[5]["nome"] : "";
      let exibe6 = !getOcultar(prioridade[6]["nome"]) ? prioridade[6]["nome"] : "";
      let exibe7 = !getOcultar(prioridade[7]["nome"]) ? prioridade[7]["nome"] : "";
      let exibe8 = !getOcultar(prioridade[8]["nome"]) ? prioridade[8]["nome"] : "";
      let exibe9 = !getOcultar(prioridade[9]["nome"]) ? prioridade[9]["nome"] : "";
      let exibe10 = !getOcultar(prioridade[10]["nome"]) ? prioridade[10]["nome"] : "";

      atualizaGraficoRelativo([exibe0, exibe1, exibe2, exibe3, exibe4, exibe5, exibe6, exibe7, exibe8, exibe9, exibe10]);*/

      /*
      atualizaGrafico(ocultaCovid, ocultaGripe, ocultaFebre, ocultaTosse, 
        ocultaDiarreia, ocultaDorDeCabeca, ocultaResfriado, ocultaFaltaDeAr, ocultaDorDeGarganta, ocultaCoriza, ocultaVomito);
      */
      
    }
  }, [semanas]);

  function getFirstDayOfWeek(ano, semana) {
    // Início do ano
    const inicioAno = startOfYear(new Date(ano, 0, 1));
  
    // A primeira semana do ano pode não começar na segunda-feira
    // Portanto, usamos startOfWeek para ajustar para o primeiro dia da semana desejado (default: Sunday)
    const primeiroDiaSemana = startOfWeek(inicioAno, { weekStartsOn: 0 }); // 0 = Domingo, 1 = Segunda-feira
  
    // Adiciona o número de semanas para encontrar o primeiro dia da semana desejada
    const dataInicialSemana = addDays(primeiroDiaSemana, (semana - 1) * 7);
  
    return dataInicialSemana;
  }

  function getLastDayOfWeek(ano, semana) {
    // Início do ano
    const inicioAno = startOfYear(new Date(ano, 0, 1));
  
    // A primeira semana do ano pode não começar na segunda-feira
    // Portanto, usamos startOfWeek para ajustar para o primeiro dia da semana desejado (default: Sunday)
    const primeiroDiaSemana = startOfWeek(inicioAno, { weekStartsOn: 0 }); // 0 = Domingo, 1 = Segunda-feira
  
    // Adiciona o número de semanas para encontrar o primeiro dia da semana desejada
    const dataInicialSemana = addDays(primeiroDiaSemana, (semana - 1) * 7);
  
    // Calcula o último dia da semana
    const ultimoDiaSemana = endOfWeek(dataInicialSemana, { weekStartsOn: 0 }); // 0 = Domingo, 1 = Segunda-feira
  
    return ultimoDiaSemana;
  }

  function carregaDatas(){
    //console.log("carregaDatas*", getHora());
    fetch(servidor + "/api/webbased/dado/pais"
      , {
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': 'Bearer ' + _logado
          }
      }
    )
    .then(response => {
      if (response.status === 401 || response.status === 404) {
        setLogado(null);    
        window.location.href = "/";
      }
      return response.json();
    })
      .then(function (myJson) {
        let tempDatas = [];
        myJson.atendimentos.sort(compararPorData);
        let tempSemanas = [];

        let tempInicioSemana = [];
        let tempFimSemana = [];

          for(let i = 0; i < myJson["atendimentos"].length; i++){
            const element = myJson["atendimentos"][i];

            tempDatas.push(element["data"]);

            tempSemanas.push(element["semana"]/*moment(element).isoWeek()*/);

            tempInicioSemana.push(format(getFirstDayOfWeek(new Date(element["data"]).getFullYear(), element["semana"]), 'yyyy/MM/dd'));
            tempFimSemana.push(format(getLastDayOfWeek(new Date(element["data"]).getFullYear(), element["semana"]), 'yyyy/MM/dd'));
          }

          setDatas(tempDatas);

          //converte datas para semanas
          
          /*for (let index = 0; index < tempDatas.length; index++) {
            const element = tempDatas[index];
          }*/
          setSemanas(tempSemanas);

          /*for (let index = 0; index < tempDatas.length; index++) {
            const element = tempDatas[index];
            tempInicioSemana.push(moment(element).startOf('isoWeek').format('YYYY-MM-DD'));
            tempFimSemana.push(moment(element).endOf('isoWeek').format('YYYY-MM-DD'));

          }*/

          setInicioSemanas(tempInicioSemana);
          setFimSemanas(tempFimSemana);

          let dtInicial = tempDatas[tempDatas.length -1] ;
          dataInicial.current = getLastYear(dtInicial);
    
          let idxDataInicio = getIdxDataInicio(tempDatas);
          let idxDataSelecionada = tempDatas.length - 1;

          
          //console.log("carregaDatas**", tempDatas, idxDataInicio, idxDataSelecionada, dataInicial.current, dtInicial, getHora());
          
          setMinDate(tempDatas[idxDataInicio]);
          setMinDateRangeInicial(tempInicioSemana[idxDataInicio]);
          setMinDateRangeFinal(tempFimSemana[idxDataInicio]);
          setMinIdxDate(idxDataInicio);
          setMaxDate(tempDatas[idxDataSelecionada]);
          setMaxIdxDate(idxDataSelecionada);
          
          setInicioSemanaSelecionada(tempInicioSemana[idxDataSelecionada]);
          setFimSemanaSelecionada(tempFimSemana[idxDataSelecionada]);
          setInicioSemanaSelecionadaRange(tempSemanas[idxDataInicio]);
          setFimSemanaSelecionadaRange(tempSemanas[idxDataSelecionada]);

          setMaxDateRangeInicial(tempInicioSemana[idxDataSelecionada]);
          setMaxDateRangeFinal(tempFimSemana[idxDataSelecionada]);

          setIniciou(true);

          
        }); 
  }

  useEffect(() => {
    // = logado;

    if(getCookie("hashCache")){
        _logado = getCookie("hashCache");
        //console.log("logado", _logado, logado);
    } else {
        //console.log("retornando a principal");
        navigate("/");
        return;
    }

    setLogado(_logado);

    
    carregaDatas();

    fetch("Dados/lista_municipios/lista_municipios_todos.json"
      , {
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': 'Bearer ' + _logado
          }
      }
    )
    .then(response => {
      if (response.status === 401 || response.status === 404) {
        setLogado(null);    
        window.location.href = "/";
      }
      return response.json();
    })
      .then(function (myJson) {
        setMunicipios(myJson);
      }); 


  }, []);

  
  const carregaCache = () => {
    //console.log("carregaCache 1");
    if (filtrandoMunicipio){
        //imprimeMensage(filtrandoMunicipio + " " + iniciou.current, "useEffect([[cod_ibge, dataSelecionada]]) 1 ");

        return;
    
    }

    setFiltrandoMunicipio(true);
    //resetShapeFile();

    if(!carregouCache){
      //console.log("carregaCache 2");
        let cod_ibge_tmp = localStorage.getItem('codibgeMunicipioSelecionadoDashboard');
        let estadoSelecionadoTmpLocal = localStorage.getItem('estadoSelecionadoDashboard');
        let municipioSelecionadoTmpLocal = localStorage.getItem('municipioSelecionadoDashboard');

        //imprimeMensage(estadoSelecionadoTmp, municipioSelecionadoTmp, estadoSelecionadoTmpLocal, municipioSelecionadoTmpLocal);

        if((estadoSelecionadoTmpLocal === null || municipioSelecionadoTmpLocal === null) || (isAllSelect(estadoSelecionadoTmpLocal) && isAllSelect(municipioSelecionadoTmpLocal))){
            //imprimeMensage("passei aqui ", estadoSelecionadoTmp, municipioSelecionadoTmp);
            //carregaDadosEstado(0);
            //console.log("Todos");
            
            setEstadoSelecionado(t("dashboard.todos"));
            setCod_Ibge(t("dashboard.todos"));
            setMunicipioSelecionado(t("dashboard.todos"));
            
            carregaDadosMunicipio(t("dashboard.todos"));
            localStorage.setItem('estadoSelecionadoDashboard', t("dashboard.todos"));
            localStorage.setItem('municipioSelecionadoDashboard', t("dashboard.todos"));
            localStorage.setItem('codibgeMunicipioSelecionadoDashboard', t("dashboard.todos"));
            //voltar aqui 
        } else if(!isAllSelect(municipioSelecionadoTmpLocal)){
            //imprimeMensage("passei aqui 2", estadoSelecionadoTmp, municipioSelecionadoTmp);
            let siglaEstado = "";
            let codigo_estado= "";            

            //imprimeMensage("useEffect cod_ibge, dataSelecionada, dados_totais", codigo_estado, siglaEstado);
           // console.log(cod_ibge_tmp, estadoSelecionadoTmpLocal, municipioSelecionadoTmpLocal);
            setEstadoSelecionado(estadoSelecionadoTmpLocal);
            
            setCod_Ibge(cod_ibge_tmp);
            
            //carregaDadosMunicipio(cod_ibge_tmp);
            setMunicipioSelecionado(municipioSelecionadoTmpLocal);

        }
        setCarregouCache(true);
    } else        
    if (isAllSelect(estadoSelecionado) && isAllSelect(municipioSelecionado)) {

        //setPopulacao("0");
        //imprimeMensage("0");

        let codigo_estado = 0;

        //carregaDadosEstado(codigo_estado);
        setMunicipioSelecionado(t("dashboard.todos"));
    } 

    //console.log("carregaCache");
    if(carregouCache && estadoSelecionado !== "" && municipioSelecionado !== "" && estadoSelecionado !== null && municipioSelecionado !== null){
        //imprimeMensage("carregouCache", estadoSelecionado, municipioSelecionado);
        
        localStorage.setItem('codibgeMunicipioSelecionadoDashboard', cod_ibge);
        localStorage.setItem('estadoSelecionadoDashboard', estadoSelecionado);
        localStorage.setItem('municipioSelecionadoDashboard', municipioSelecionado);
    }

    setFiltrandoMunicipio(false);
    carregandoEstado.current = false;
    
};

  useEffect(() => {
    if(iniciou){
      carregaCache();
      
      let dtInicial = datas[datas.length -1] ;
      dataInicial.current = getLastYear(dtInicial);
      let idxDataInicio = getIdxDataInicio(datas);
      let idxDataSelecionada = datas.length - 1;
      setValueRangeData([idxDataInicio,idxDataSelecionada]);
      /*let dtInicial = datas[datas.length -1] ;
      dataInicial.current = getLastYear(dtInicial);

      let idxDataInicio = getIdxDataInicio(datas);
      let idxDataSelecionada = datas.length - 1;

      setMinDate(datas[idxDataInicio]);
      setMinDateRangeInicial(inicioSemanas[idxDataInicio]);
      setMinDateRangeFinal(fimSemanas[idxDataInicio]);
      setMinIdxDate(idxDataInicio);
      setMaxDate(datas[idxDataSelecionada]);
      setMaxIdxDate(idxDataSelecionada);
      
      setMaxDateRangeInicial(inicioSemanas[idxDataSelecionada]);
      setMaxDateRangeFinal(fimSemanas[idxDataSelecionada]);
      
      setValueRangeData([idxDataInicio,idxDataSelecionada]);
      //setSemanaSelecionada(semanas[idxDataSelecionada]);
      setInicioSemanaSelecionada(inicioSemanas[idxDataSelecionada]);
      setFimSemanaSelecionada(fimSemanas[idxDataSelecionada]);
      setInicioSemanaSelecionadaRange(semanas[idxDataInicio]);
      setFimSemanaSelecionadaRange(semanas[idxDataSelecionada]); */

      //carregaCache();

      //console.log("setou datas", idxDataInicio, idxDataSelecionada, datas[idxDataInicio], datas[idxDataSelecionada], dataInicial.current, semanas[idxDataInicio], semanas[idxDataSelecionada], inicioSemanas[idxDataSelecionada], fimSemanas[idxDataSelecionada]);

      //let co_ibge =  t("dashboard.todos");
      //carregaDadosMunicipio(co_ibge);
      
      //console.log("iniciou");
    }
  }, [iniciou]);

  var corLinhaMarcaoGrafico = ("rgba(94, 94, 94, 1)");

  function FormatarDoisDigitos(numero) {
    if(numero === null || numero === undefined)
        return "00";
    return numero.toString().padStart(2, '0');
  }

  const getWeekStartingSunday = (date) => {
    // Calcula o primeiro dia do ano e ajusta para começar no domingo
    const startOfYearDate = startOfYear(date);
    const startOfFirstWeek = new Date(startOfYearDate);
    startOfFirstWeek.setDate(
      startOfYearDate.getDate() - startOfYearDate.getDay()
    );
  
    // Calcula o número de dias desde o início da primeira semana
    const dayOfYear = differenceInCalendarDays(date, startOfFirstWeek);
  
    // Calcula a semana do ano, ajustando para começar no domingo
    return Math.floor(dayOfYear / 7) + 1;
  };

  function exibeMesAnoGrafico(index, values){

    const totalTicks = values.length;

    const date = moment(values[index].value);
    
    const week = getISOWeek(new Date(values[index].value), { weekStartsOn: 0 }) +1 ;

    //const week = getWeekStartingSunday(new Date(values[index].value));

    // retorne a semana

    // Sempre mostre o primeiro e o último tick
    /*if (index === 0 || index === totalTicks - 1) {
        return `${FormatarDoisDigitos(date.isoWeek())}-${date.year()}`;
    }*/

    // Lógica para mostrar ticks intermediários
    let intermediateTicks = 10; // número de ticks intermediários desejados

    let totalWeekTicks = Math.floor(totalTicks / 7);

    if(totalWeekTicks < intermediateTicks)
        intermediateTicks = totalWeekTicks - 2;
        if(intermediateTicks < 0)
            intermediateTicks = 0;

    const stepSize = Math.floor(totalTicks / (intermediateTicks + 1));

    if (index % stepSize === 0) {
        return `${FormatarDoisDigitos(week)}-${date.year()}`;
    }

    return null; // Não mostra outros ticks
}

/*function triggerLegendClick(chart, datasetIndex) {
  console.log(chart);
  const legend = chart.current.legend;
  console.log(legend);

  const legendItem = legend.legendItems[datasetIndex];

  // Simula o evento de clique
  const clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
  });

  legendItem.$context = {
      chart: chart,
      dataIndex: datasetIndex,
      datasetIndex: datasetIndex,
      index: datasetIndex,
      element: null
  };

  legendItem.$handlers.onClick(clickEvent, legendItem);
}*/
function atualizaGraficoRelativo(termos, tempData){
       //console.log("atualizaGraficoRelativo", termos, tempData);
 /*let dadosGripalTemp = [];*/
       let dadosCorizaTemp = [];
       let dadosCovidTemp = [];
       let dadosDiarreiaTemp = [];
       let dadosDorDeCabecaTemp = [];
       let dadosDorDeGargantaTemp = [];
       let dadosFaltaDeArTemp = [];
       let dadosFebreTemp = [];
       let dadosGripeTemp = [];
       let dadosResfriadoTemp = [];
       let dadosTosseTemp = [];
       let dadosVomitoTemp = [];

       /*let dadosGripalTemp2023 = [];*/
       let dadosCorizaTempMediaMovel = [];
       let dadosCovidTempMediaMovel = [];
       let dadosDiarreiaTempMediaMovel = [];
       let dadosDorDeCabecaTempMediaMovel = [];
       let dadosDorDeGargantaTempMediaMovel = [];
       let dadosFaltaDeArTempMediaMovel = [];
       let dadosFebreTempMediaMovel = [];
       let dadosGripeTempMediaMovel = [];
       let dadosResfriadoTempMediaMovel = [];
       let dadosTosseTempMediaMovel = [];
       let dadosVomitoTempMediaMovel = [];

       let maiorValor = 0;

       let datasLocal = [];
       if(tempData && tempData.length > 0){
        datasLocal = tempData;
       } else {
        datasLocal = datas;
       }

       //console.log(datasLocal[minIdxDate], datasLocal[maxIdxDate], minIdxDate, maxIdxDate, datasLocal, dadosCoriza.current, dadosCovid.current, dadosDiarreia.current, dadosDorDeCabeca.current, dadosDorDeGarganta.current, dadosFaltaDeAr.current, dadosFebre.current, dadosGripe.current, dadosResfriado.current, dadosTosse.current, dadosVomito.current);
       
       Object.keys(dadosCoriza.current).forEach((key) => {
        
         if(key >= datasLocal[minIdxDate] && key <= datasLocal[maxIdxDate]){

           let resultado = calculo_sintomas_relativos(termos, getDados(0)[key],
             getDados(1)[key], getDados(2)[key], getDados(3)[key], getDados(4)[key], 
             getDados(5)[key], getDados(6)[key], getDados(7)[key], 
             getDados(8)[key], getDados(9)[key], getDados(10)[key]);

           //console.log("passei aqui");
          // console.log(key, getDados(0), getDados(1), getDados(2), getDados(3), getDados(4), getDados(5), getDados(6), getDados(7), getDados(8), getDados(9), getDados(10), resultado);

           const dataReferencia = moment('2023-01-01 00:00:00', 'YYYY-MM-DD HH:mm:ss');
           const dataConvertida = moment(key, 'YYYY-MM-DD HH:mm:ss');

           var obj2 = {};
           obj2['data'] = key;
           let indice = getIndiceTermo("coriza", prioridade.current);
           let yCoriza = resultado['y'+(indice+1)+'_'] ? resultado['y'+(indice+1)+'_'] : null;
           //console.log('y'+(indice+1)+'_', yCoriza);
           obj2['total'] = yCoriza;/*dadosCoriza.current[key];*/
           dadosCorizaTemp.push(obj2);
           dadosCorizaTempMediaMovel.push(obj2);
           
           var obj3 = {};
           obj3['data'] = key;
           obj3['total'] = dadosCovid.current[key];
           dadosCovidTemp.push(obj3);
           dadosCovidTempMediaMovel.push(obj3);
           
           var obj4 = {};
           obj4['data'] = key;
           indice = getIndiceTermo("diarreia", prioridade.current);
           obj4['total'] = resultado['y'+(indice+1)+'_'] ? resultado['y'+(indice+1)+'_'] : null; /*dadosDiarreia.current[key];*/
           //console.log('y'+(indice+1)+'_');
           dadosDiarreiaTemp.push(obj4);
           dadosDiarreiaTempMediaMovel.push(obj4);
           
           var obj5 = {};
           obj5['data'] = key;
           indice = getIndiceTermo("dor_de_cabeca", prioridade.current);
           obj5['total'] = resultado['y'+(indice+1)+'_'] ? resultado['y'+(indice+1)+'_'] : null; /*dadosDorDeCabeca.current[key];*/
           //console.log('y'+(indice+1)+'_');
           dadosDorDeCabecaTemp.push(obj5);
           dadosDorDeCabecaTempMediaMovel.push(obj5);
           

           var obj6 = {};
           obj6['data'] = key;
           indice = getIndiceTermo("dor_de_garganta", prioridade.current);
           obj6['total'] = resultado['y'+(indice+1)+'_'] ? resultado['y'+(indice+1)+'_'] : null; /*dadosDorDeGarganta.current[key];*/
           //console.log('y'+(indice+1)+'_');  
           dadosDorDeGargantaTemp.push(obj6);
           dadosDorDeGargantaTempMediaMovel.push(obj6);
           

           var obj7 = {};
           obj7['data'] = key;
           indice = getIndiceTermo("falta_de_ar", prioridade.current);
           obj7['total'] = resultado['y'+(indice+1)+'_'] ? resultado['y'+(indice+1)+'_'] : null; /*dadosFaltaDeAr.current[key];*/
           dadosFaltaDeArTemp.push(obj7);
           dadosFaltaDeArTempMediaMovel.push(obj7);
           

           var obj8 = {};
           obj8['data'] = key;
           indice = getIndiceTermo("febre", prioridade.current);
           obj8['total'] = resultado['y'+(indice+1)+'_'] ? resultado['y'+(indice+1)+'_'] : null; /*dadosFebre.current[key];*/
           dadosFebreTemp.push(obj8);
           dadosFebreTempMediaMovel.push(obj8);
           

           var obj9 = {};
           obj9['data'] = key;
           indice = getIndiceTermo("gripe", prioridade.current);
           obj9['total'] = resultado['y'+(indice+1)+'_'] ? resultado['y'+(indice+1)+'_'] : null; /*dadosGripe.current[key];*/
           dadosGripeTemp.push(obj9);
           dadosGripeTempMediaMovel.push(obj9);
           

           var obj10 = {};
           obj10['data'] = key;
           indice = getIndiceTermo("resfriado", prioridade.current);
           obj10['total'] = resultado['y'+(indice+1)+'_'] ? resultado['y'+(indice+1)+'_'] : null; /*dadosResfriado.current[key]*/;
           dadosResfriadoTemp.push(obj10);
           dadosResfriadoTempMediaMovel.push(obj10);
           

           var obj11 = {};
           obj11['data'] = key;
           indice = getIndiceTermo("tosse", prioridade.current);
           obj11['total'] = resultado['y'+(indice+1)+'_'] ? resultado['y'+(indice+1)+'_'] : null;; /*dadosTosse.current[key];*/
           dadosTosseTemp.push(obj11);
           dadosTosseTempMediaMovel.push(obj11);
           

           var obj12 = {};
           obj12['data'] = key;
           indice = getIndiceTermo("vomito", prioridade.current);
           //console.log('y'+(indice+1)+'_', resultado['y'+(indice+1)+'_']);
           obj12['total'] = resultado['y'+(indice+1)+'_'] ? resultado['y'+(indice+1)+'_'] : null; /*dadosVomito.current[key];*/
           dadosVomitoTemp.push(obj12);
           dadosVomitoTempMediaMovel.push(obj12);
          
         }

       });

      let covid = getOcultar("covid");
      let gripe = getOcultar("gripe");
      let febre = getOcultar("febre");
      let tosse = getOcultar("tosse");
      let diarreia = getOcultar("diarreia");
      let dor_de_cabeca = getOcultar("dor_de_cabeca");
      let resfriado = getOcultar("resfriado");
      let falta_de_ar = getOcultar("falta_de_ar");
      let dor_de_garganta = getOcultar("dor_de_garganta");
      let coriza = getOcultar("coriza");
      let vomito = getOcultar("vomito");

       for (let key = 0; key < dadosCorizaTemp.length; key++) {
         if(!coriza && dadosCorizaTemp[key]["total"] > maiorValor)
           maiorValor = dadosCorizaTemp[key]["total"];
         if(!covid && dadosCovidTemp[key]["total"] > maiorValor)
           maiorValor = dadosCovidTemp[key]["total"];
         if(!diarreia && dadosDiarreiaTemp[key]["total"] > maiorValor)
           maiorValor = dadosDiarreiaTemp[key]["total"];
         if(!dor_de_cabeca && dadosDorDeCabecaTemp[key]["total"] > maiorValor)
           maiorValor = dadosDorDeCabecaTemp[key]["total"];
         if(!dor_de_garganta && dadosDorDeGargantaTemp[key]["total"] > maiorValor)
           maiorValor = dadosDorDeGargantaTemp[key]["total"];
         if(!falta_de_ar && dadosFaltaDeArTemp[key]["total"] > maiorValor)
           maiorValor = dadosFaltaDeArTemp[key]["total"];
         if(!febre && dadosFebreTemp[key]["total"] > maiorValor)
           maiorValor = dadosFebreTemp[key]["total"];
         if(!gripe && dadosGripeTemp[key]["total"] > maiorValor)
           maiorValor = dadosGripeTemp[key]["total"];
         if(!resfriado && dadosResfriadoTemp[key]["total"] > maiorValor)
           maiorValor = dadosResfriadoTemp[key]["total"];
         if(!tosse && dadosTosseTemp[key]["total"] > maiorValor)
           maiorValor = dadosTosseTemp[key]["total"];
         if(!vomito && dadosVomitoTemp[key]["total"] > maiorValor)
           maiorValor = dadosVomitoTemp[key]["total"];
         /*if(!coriza && dadosCorizaTemp[key]["total"] > maiorValor)
           maiorValor = dadosCorizaTemp[key]["total"]; */          
       };
       
       let multiplicador = maiorValor == 0 ? 1 : 100 / maiorValor;

       //aplique o multiplicador para todos os valores
       for (let key = 0; key < dadosCorizaTemp.length; key++) {
         dadosCorizaTemp[key]['total'] = dadosCorizaTemp[key]['total'] * multiplicador;
         dadosCovidTemp[key]['total'] = dadosCovidTemp[key]['total'] * multiplicador;
         dadosDiarreiaTemp[key]['total'] = dadosDiarreiaTemp[key]['total'] * multiplicador;
         dadosDorDeCabecaTemp[key]['total'] = dadosDorDeCabecaTemp[key]['total'] * multiplicador;
         dadosDorDeGargantaTemp[key]['total'] = dadosDorDeGargantaTemp[key]['total'] * multiplicador;
         dadosFaltaDeArTemp[key]['total'] = dadosFaltaDeArTemp[key]['total'] * multiplicador;
         dadosFebreTemp[key]['total'] = dadosFebreTemp[key]['total'] * multiplicador;
         dadosGripeTemp[key]['total'] = dadosGripeTemp[key]['total'] * multiplicador;
         dadosResfriadoTemp[key]['total'] = dadosResfriadoTemp[key]['total'] * multiplicador;
         dadosTosseTemp[key]['total'] = dadosTosseTemp[key]['total'] * multiplicador;
         dadosVomitoTemp[key]['total'] = dadosVomitoTemp[key]['total'] * multiplicador;
       };
 
       /*
       dadosGripalTemp = Object.fromEntries(
         dadosGripalTemp.map(({data, total}) => [data, total])
       ); */

      //pegando o ultimo termo
       if(dadosCorizaTemp.length > 0){
        setUltimoValorCovid(dadosCovidTemp[dadosCovidTemp.length - 1]["total"]);
        setUltimoValorCoriza(dadosCorizaTemp[dadosCorizaTemp.length - 1]["total"]);
        setUltimoValorDiarreia(dadosDiarreiaTemp[dadosDiarreiaTemp.length - 1]["total"]);
        setUltimoValorDorDeCabeca(dadosDorDeCabecaTempMediaMovel[dadosDorDeCabecaTemp.length - 1]["total"]);
        setUltimoValorDorDeGarganta(dadosDorDeGargantaTemp[dadosDorDeGargantaTemp.length - 1]["total"]);
        setUltimoValorFaltaDeAr(dadosFaltaDeArTemp[dadosFaltaDeArTemp.length - 1]["total"]);
        setUltimoValorFebre(dadosFebreTemp[dadosFebreTemp.length - 1]["total"]);
        setUltimoValorGripe(dadosGripeTemp[dadosGripeTemp.length - 1]["total"]);
        setUltimoValorResfriado(dadosResfriadoTemp[dadosResfriadoTemp.length - 1]["total"]);
        setUltimoValorTosse(dadosTosseTemp[dadosTosseTemp.length - 1]["total"]);
        setUltimoValorVomito(dadosVomitoTemp[dadosVomitoTemp.length - 1]["total"]);
       }


      if(dadosCovidTemp.length > 0){

        setUltimoValorCovidMM(dadosCovidTempMediaMovel[dadosCovidTempMediaMovel.length - 1]["total"]);
        setUltimoValorCorizaMM(dadosCorizaTempMediaMovel[dadosCorizaTempMediaMovel.length - 1]["total"]);
        setUltimoValorDiarreiaMM(dadosDiarreiaTempMediaMovel[dadosDiarreiaTempMediaMovel.length - 1]["total"]);
        setUltimoValorDorDeCabecaMM(dadosDorDeCabecaTempMediaMovel[dadosDorDeCabecaTempMediaMovel.length - 1]["total"]);
        setUltimoValorDorDeGargantaMM(dadosDorDeGargantaTempMediaMovel[dadosDorDeGargantaTempMediaMovel.length - 1]["total"]);
        setUltimoValorFaltaDeArMM(dadosFaltaDeArTempMediaMovel[dadosFaltaDeArTempMediaMovel.length - 1]["total"]);
        setUltimoValorFebreMM(dadosFebreTempMediaMovel[dadosFebreTempMediaMovel.length - 1]["total"]);
        setUltimoValorGripeMM(dadosGripeTempMediaMovel[dadosGripeTempMediaMovel.length - 1]["total"]);
        setUltimoValorResfriadoMM(dadosResfriadoTempMediaMovel[dadosResfriadoTempMediaMovel.length - 1]["total"]);
        setUltimoValorTosseMM(dadosTosseTempMediaMovel[dadosTosseTempMediaMovel.length - 1]["total"]);
        setUltimoValorVomitoMM(dadosVomitoTempMediaMovel[dadosVomitoTempMediaMovel.length - 1]["total"]);
        //setUltimoValorAPS(dadosGripalMediaMovel[dadosGripalMediaMovel.length - 1]["total"]);
      }

       dadosCorizaTemp = Object.fromEntries(
         dadosCorizaTemp.map(({data, total}) => [data, total])
       );

       dadosCovidTemp = Object.fromEntries(
         dadosCovidTemp.map(({data, total}) => [data, total])
       );

       dadosDiarreiaTemp = Object.fromEntries(
         dadosDiarreiaTemp.map(({data, total}) => [data, total])
       );

       dadosDorDeCabecaTemp = Object.fromEntries(
         dadosDorDeCabecaTemp.map(({data, total}) => [data, total])
       );

       dadosDorDeGargantaTemp = Object.fromEntries(
         dadosDorDeGargantaTemp.map(({data, total}) => [data, total])
       );

       dadosFaltaDeArTemp = Object.fromEntries(
         dadosFaltaDeArTemp.map(({data, total}) => [data, total])
       );

       dadosFebreTemp = Object.fromEntries(
         dadosFebreTemp.map(({data, total}) => [data, total])
       );

       dadosGripeTemp = Object.fromEntries(
         dadosGripeTemp.map(({data, total}) => [data, total])
       );

       dadosResfriadoTemp = Object.fromEntries(
         dadosResfriadoTemp.map(({data, total}) => [data, total])
       );

       dadosTosseTemp = Object.fromEntries(
         dadosTosseTemp.map(({data, total}) => [data, total])
       );

       dadosVomitoTemp = Object.fromEntries(
         dadosVomitoTemp.map(({data, total}) => [data, total])
       );

       dadosCorizaTempMediaMovel = Object.fromEntries(
         dadosCorizaTempMediaMovel.map(({data, total}) => [data, total])
       );

       dadosCovidTempMediaMovel = Object.fromEntries(
         dadosCovidTempMediaMovel.map(({data, total}) => [data, total])
       );

       dadosDiarreiaTempMediaMovel = Object.fromEntries(
         dadosDiarreiaTempMediaMovel.map(({data, total}) => [data, total])
       );

       dadosDorDeCabecaTempMediaMovel = Object.fromEntries(
         dadosDorDeCabecaTempMediaMovel.map(({data, total}) => [data, total])
       );

       dadosDorDeGargantaTempMediaMovel = Object.fromEntries(
         dadosDorDeGargantaTempMediaMovel.map(({data, total}) => [data, total])
       );

       dadosFaltaDeArTempMediaMovel = Object.fromEntries(
         dadosFaltaDeArTempMediaMovel.map(({data, total}) => [data, total])
       );

       dadosFebreTempMediaMovel = Object.fromEntries(
         dadosFebreTempMediaMovel.map(({data, total}) => [data, total])
       );

       dadosGripeTempMediaMovel = Object.fromEntries(
         dadosGripeTempMediaMovel.map(({data, total}) => [data, total])
       );

       dadosResfriadoTempMediaMovel = Object.fromEntries(
         dadosResfriadoTempMediaMovel.map(({data, total}) => [data, total])
       );

       dadosTosseTempMediaMovel = Object.fromEntries(
         dadosTosseTempMediaMovel.map(({data, total}) => [data, total])
       );

       dadosVomitoTempMediaMovel = Object.fromEntries(
         dadosVomitoTempMediaMovel.map(({data, total}) => [data, total])
       );

       if(ocultaCoriza)
        dadosCorizaTemp = [];

      if(ocultaCovid)
        dadosCovidTemp = [];

      if(ocultaDiarreia)
        dadosDiarreiaTemp = [];

      if(ocultaDorDeCabeca)
        dadosDorDeCabecaTemp = [];

      if(ocultaDorDeGarganta)
        dadosDorDeGargantaTemp = [];

      if(ocultaFaltaDeAr)
        dadosFaltaDeArTemp = [];

      if(ocultaFebre)
        dadosFebreTemp = [];

      if(ocultaGripe)
        dadosGripeTemp = [];

      if(ocultaResfriado)
        dadosResfriadoTemp = [];

      if(ocultaTosse)
        dadosTosseTemp = [];

      if(ocultaVomito)
        dadosVomitoTemp = [];

       //exibir somente os selecionados

       
       //console.log(getDadosGraficoTodos(t("dashboard.graficos.titulo_atendimento_gripais"), dadosGripalMediaMovel.current, t("dashboard.variaveisGoogle.coriza"), dadosCorizaTempMediaMovel, t("dashboard.variaveisGoogle.covid"), dadosCovidTempMediaMovel, t("dashboard.variaveisGoogle.diarreia"), dadosDiarreiaTempMediaMovel, t("dashboard.variaveisGoogle.dor_de_cabeca"), dadosDorDeCabecaTempMediaMovel, t("dashboard.variaveisGoogle.dor_de_garganta"), dadosDorDeGargantaTempMediaMovel, t("dashboard.variaveisGoogle.falta_de_ar"), dadosFaltaDeArTempMediaMovel, t("dashboard.variaveisGoogle.febre"), dadosFebreTempMediaMovel, t("dashboard.variaveisGoogle.gripe"), dadosGripeTempMediaMovel, t("dashboard.variaveisGoogle.resfriado"), dadosResfriadoTempMediaMovel, t("dashboard.variaveisGoogle.tosse"), dadosTosseTempMediaMovel, t("dashboard.variaveisGoogle.vomito"), dadosVomitoTempMediaMovel, false).datasets);
      
      //console.log(ocultaCoriza, ocultaCovid, ocultaDiarreia, ocultaDorDeCabeca, ocultaDorDeGarganta, ocultaFaltaDeAr, ocultaFebre, ocultaGripe, ocultaResfriado, ocultaTosse, ocultaVomito);
      //console.log("atualizaGraficoRelativo", dadosCorizaTemp, dadosCovidTemp, dadosDiarreiaTemp, dadosDorDeCabecaTemp, dadosDorDeGargantaTemp, dadosFaltaDeArTemp, dadosFebreTemp, dadosGripeTemp, dadosResfriadoTemp, dadosTosseTemp, dadosVomitoTemp);
      //console.log(dadosCorizaTemp, dadosCovidTemp, dadosDiarreiaTemp, dadosDorDeCabecaTemp, dadosDorDeGargantaTemp, dadosFaltaDeArTemp, dadosFebreTemp, dadosGripeTemp, dadosResfriadoTemp, dadosTosseTemp, dadosVomitoTemp);
      
      setDadosAtendimentoTodos(getDadosGraficoTodos(t("dashboard.graficos.titulo_atendimento_gripais"), dadosGripal.current, t("dashboard.variaveisGoogle.coriza"), dadosCorizaTemp, t("dashboard.variaveisGoogle.covid"), dadosCovidTemp, t("dashboard.variaveisGoogle.diarreia"), dadosDiarreiaTemp, t("dashboard.variaveisGoogle.dor_de_cabeca"), dadosDorDeCabecaTemp, t("dashboard.variaveisGoogle.dor_de_garganta"), dadosDorDeGargantaTemp, t("dashboard.variaveisGoogle.falta_de_ar"), dadosFaltaDeArTemp, t("dashboard.variaveisGoogle.febre"), dadosFebreTemp, t("dashboard.variaveisGoogle.gripe"), dadosGripeTemp, t("dashboard.variaveisGoogle.resfriado"), dadosResfriadoTemp, t("dashboard.variaveisGoogle.tosse"), dadosTosseTemp, t("dashboard.variaveisGoogle.vomito"), dadosVomitoTemp, false));
        
      setDadosAtendimentoTodosMediaMovel(getDadosGraficoTodos(t("dashboard.graficos.titulo_atendimento_gripais"), dadosGripalMediaMovel.current, t("dashboard.variaveisGoogle.coriza"), dadosCorizaTempMediaMovel, t("dashboard.variaveisGoogle.covid"), dadosCovidTempMediaMovel, t("dashboard.variaveisGoogle.diarreia"), dadosDiarreiaTempMediaMovel, t("dashboard.variaveisGoogle.dor_de_cabeca"), dadosDorDeCabecaTempMediaMovel, t("dashboard.variaveisGoogle.dor_de_garganta"), dadosDorDeGargantaTempMediaMovel, t("dashboard.variaveisGoogle.falta_de_ar"), dadosFaltaDeArTempMediaMovel, t("dashboard.variaveisGoogle.febre"), dadosFebreTempMediaMovel, t("dashboard.variaveisGoogle.gripe"), dadosGripeTempMediaMovel, t("dashboard.variaveisGoogle.resfriado"), dadosResfriadoTempMediaMovel, t("dashboard.variaveisGoogle.tosse"), dadosTosseTempMediaMovel, t("dashboard.variaveisGoogle.vomito"), dadosVomitoTempMediaMovel, false));
       

    }

        const options = {
          animation: false,
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              onClick: null,
              /*
              onClick: (e, legendItem, legend) => {
                const index = legendItem.datasetIndex;
                const ci = legend.chart;
                const meta = ci.getDatasetMeta(index);
                
                // Alterna a visibilidade da variável
                meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

                ci.update();
      
                let ocultaCovidTemp = ocultaCovid;
                let ocultaGripeTemp = ocultaGripe;
                let ocultaFebreTemp = ocultaFebre;
                let ocultaTosseTemp = ocultaTosse;
                let ocultaDiarreiaTemp = ocultaDiarreia;
                let ocultaDorDeCabecaTemp = ocultaDorDeCabeca;
                let ocultaResfriadoTemp = ocultaResfriado;
                let ocultaFaltaDeArTemp = ocultaFaltaDeAr;
                let ocultaDorDeGargantaTemp = ocultaDorDeGarganta;
                let ocultaCorizaTemp = ocultaCoriza;
                let ocultaVomitoTemp = ocultaVomito;
      
                switch (index) {
                  case 2:{
                    setOcultaCovid(meta.hidden ? true : false);
                    ocultaCovidTemp = meta.hidden ? true : false;
                    break;
                  }
                  case 8:{
                    setOcultaGripe(meta.hidden ? true : false);
                    ocultaGripeTemp = meta.hidden ? true : false;
                    break;
                  }
                  case 7:{
                    setOcultaFebre(meta.hidden ? true : false);
                    ocultaFebreTemp = meta.hidden ? true : false;
                    break;
                  }
                  case 10:{
                    setOcultaTosse(meta.hidden ? true : false);
                    ocultaTosseTemp = meta.hidden ? true : false;
                    break;
                  }
                  case 3:{
                    setOcultaDiarreia(meta.hidden ? true : false);
                    ocultaDiarreiaTemp = meta.hidden ? true : false;
                    break;
                  }
                  case 4:{
                    setOcultaDorDeCabeca(meta.hidden ? true : false);
                    ocultaDorDeCabecaTemp = meta.hidden ? true : false;
                    break;
                  }
                  case 9:{
                    setOcultaResfriado(meta.hidden ? true : false);
                    ocultaResfriadoTemp = meta.hidden ? true : false;
                    break;
                  }
                  case 6:{
                    setOcultaFaltaDeAr(meta.hidden ? true : false);
                    ocultaFaltaDeArTemp = meta.hidden ? true : false;
                    break;
                  }
                  case 5:{
                    setOcultaDorDeGarganta(meta.hidden ? true : false);
                    ocultaDorDeGargantaTemp = meta.hidden ? true : false;
                    break;
                  }
                  case 1:{
                    setOcultaCoriza(meta.hidden ? true : false);
                    ocultaCorizaTemp = meta.hidden ? true : false;
                    break;
                  }
                  case 11:{
                    setOcultaVomito(meta.hidden ? true : false);
                    ocultaVomitoTemp = meta.hidden ? true : false;
                    break;
                  }
                  default:
                    break;
                }

                let exibe0 = !getOcultarTemp(prioridade.current[0]["nome"], ocultaCovidTemp, ocultaGripeTemp, ocultaFebreTemp, ocultaTosseTemp, ocultaDiarreiaTemp, ocultaDorDeCabecaTemp, ocultaResfriadoTemp, ocultaFaltaDeArTemp, ocultaDorDeGargantaTemp, ocultaCorizaTemp, ocultaVomitoTemp) ? prioridade.current[0]["nome"] : "";
                let exibe1 = !getOcultarTemp(prioridade.current[1]["nome"], ocultaCovidTemp, ocultaGripeTemp, ocultaFebreTemp, ocultaTosseTemp, ocultaDiarreiaTemp, ocultaDorDeCabecaTemp, ocultaResfriadoTemp, ocultaFaltaDeArTemp, ocultaDorDeGargantaTemp, ocultaCorizaTemp, ocultaVomitoTemp) ? prioridade.current[1]["nome"] : "";
                let exibe2 = !getOcultarTemp(prioridade.current[2]["nome"], ocultaCovidTemp, ocultaGripeTemp, ocultaFebreTemp, ocultaTosseTemp, ocultaDiarreiaTemp, ocultaDorDeCabecaTemp, ocultaResfriadoTemp, ocultaFaltaDeArTemp, ocultaDorDeGargantaTemp, ocultaCorizaTemp, ocultaVomitoTemp) ? prioridade.current[2]["nome"] : "";
                let exibe3 = !getOcultarTemp(prioridade.current[3]["nome"], ocultaCovidTemp, ocultaGripeTemp, ocultaFebreTemp, ocultaTosseTemp, ocultaDiarreiaTemp, ocultaDorDeCabecaTemp, ocultaResfriadoTemp, ocultaFaltaDeArTemp, ocultaDorDeGargantaTemp, ocultaCorizaTemp, ocultaVomitoTemp) ? prioridade.current[3]["nome"] : "";
                let exibe4 = !getOcultarTemp(prioridade.current[4]["nome"], ocultaCovidTemp, ocultaGripeTemp, ocultaFebreTemp, ocultaTosseTemp, ocultaDiarreiaTemp, ocultaDorDeCabecaTemp, ocultaResfriadoTemp, ocultaFaltaDeArTemp, ocultaDorDeGargantaTemp, ocultaCorizaTemp, ocultaVomitoTemp) ? prioridade.current[4]["nome"] : "";
                let exibe5 = !getOcultarTemp(prioridade.current[5]["nome"], ocultaCovidTemp, ocultaGripeTemp, ocultaFebreTemp, ocultaTosseTemp, ocultaDiarreiaTemp, ocultaDorDeCabecaTemp, ocultaResfriadoTemp, ocultaFaltaDeArTemp, ocultaDorDeGargantaTemp, ocultaCorizaTemp, ocultaVomitoTemp) ? prioridade.current[5]["nome"] : "";
                let exibe6 = !getOcultarTemp(prioridade.current[6]["nome"], ocultaCovidTemp, ocultaGripeTemp, ocultaFebreTemp, ocultaTosseTemp, ocultaDiarreiaTemp, ocultaDorDeCabecaTemp, ocultaResfriadoTemp, ocultaFaltaDeArTemp, ocultaDorDeGargantaTemp, ocultaCorizaTemp, ocultaVomitoTemp) ? prioridade.current[6]["nome"] : "";
                let exibe7 = !getOcultarTemp(prioridade.current[7]["nome"], ocultaCovidTemp, ocultaGripeTemp, ocultaFebreTemp, ocultaTosseTemp, ocultaDiarreiaTemp, ocultaDorDeCabecaTemp, ocultaResfriadoTemp, ocultaFaltaDeArTemp, ocultaDorDeGargantaTemp, ocultaCorizaTemp, ocultaVomitoTemp)? prioridade.current[7]["nome"] : "";
                let exibe8 = !getOcultarTemp(prioridade.current[8]["nome"], ocultaCovidTemp, ocultaGripeTemp, ocultaFebreTemp, ocultaTosseTemp, ocultaDiarreiaTemp, ocultaDorDeCabecaTemp, ocultaResfriadoTemp, ocultaFaltaDeArTemp, ocultaDorDeGargantaTemp, ocultaCorizaTemp, ocultaVomitoTemp) ? prioridade.current[8]["nome"] : "";
                let exibe9 = !getOcultarTemp(prioridade.current[9]["nome"], ocultaCovidTemp, ocultaGripeTemp, ocultaFebreTemp, ocultaTosseTemp, ocultaDiarreiaTemp, ocultaDorDeCabecaTemp, ocultaResfriadoTemp, ocultaFaltaDeArTemp, ocultaDorDeGargantaTemp, ocultaCorizaTemp, ocultaVomitoTemp) ? prioridade.current[9]["nome"] : "";
                let exibe10 = !getOcultarTemp(prioridade.current[10]["nome"], ocultaCovidTemp, ocultaGripeTemp, ocultaFebreTemp, ocultaTosseTemp, ocultaDiarreiaTemp, ocultaDorDeCabecaTemp, ocultaResfriadoTemp, ocultaFaltaDeArTemp, ocultaDorDeGargantaTemp, ocultaCorizaTemp, ocultaVomitoTemp) ? prioridade.current[10]["nome"] : "";
      
                atualizaGraficoRelativo([exibe0, exibe1, exibe2, exibe3, exibe4, exibe5, exibe6, exibe7, exibe8, exibe9, exibe10]);
              },*/
              position: 'bottom',
              align: 'start',
              labels: {
                boxWidth: 15,
                color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
                font: { 
                  size: 10
                },
                filter: function(legendItem, chartData) {
                  // Filtrar para remover 'Dataset 2'
                  //console.log(legendItem["datasetIndex"], chartData, chartData["datasets"][legendItem["datasetIndex"]]/*, !chartData[legendItem["datasetIndex"]]["hidden"]*/);
                  return chartData["datasets"][legendItem["datasetIndex"]] === undefined || !chartData["datasets"][legendItem["datasetIndex"]]["hidden"];
                }
              }
            },
            title: {
              display: false,
              color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
              text: 'Chart.js Line Chart',
            },
            /*annotation: {
              annotations: [
                {
                  type: 'line',
                  mode: 'vertical',
                  scaleID: 'x',
                  value: "2024-03-02",
                  borderColor: corLinhaMarcaoGrafico,
                  borderWidth: 1,
                },
              ],
            },*/
          },
          scales: {
            y:{
              type: 'linear',
              display: true,
              position: 'left',
              id: 'y-axis-1',
              labelString: 'Dataset 1',
              afterBuildTicks: function(scale) {
                scale.ticks.forEach(function(tick, index, ticks) {
                  ticks[index].color = 'rgba(75,192,192,1)'; // Cor da escala do primeiro eixo y
                });
              },
              title: {
                display: true,
                text: t("dashboard.graficos.titulo_atendimento_gripais"), // Texto do título do eixo Y
                color: theme === "dark" ? "#FFFFFF" : "#000000",
                font: {
                    size: 12,
                    weight: 'bold'
                }
              },
              grid: {
                    color: theme === "dark" ? "#5d5f69" : '#ccc',
              },
            },
            y2:{
              type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                labelString: 'Dataset 2',
                afterBuildTicks: function(scale) {
                  scale.ticks.forEach(function(tick, index, ticks) {
                    ticks[index].color = 'rgba(255, 99, 132, 1)'; // Cor da escala do segundo eixo y
                  });
                },
                title: {
                  display: true,
                  text: t("dashboard.variaveisGoogle.termos"), // Texto do título do eixo Y
                  color: theme === "dark" ? "#FFFFFF" : "#000000",
                  font: {
                      size: 12,
                      weight: 'bold'
                  }
                },
                grid: {
                    color: theme === "dark" ? "#5d5f69" : '#ccc',
                },
            },
            /*x:{
              type: 'time',
              time: {
                parser: 'YYYY/MM/DD',
                unit: 'day',
                displayFormats: {
                  'day': 'DD/MM/YYYY',
                  'month' : 'DD/MM/YYYY'
                },
              },
              ticks:{
                callback: function(value, index, values) {
                  // Converte a data em um objeto moment
                 
                  return exibeMesAnoGrafico(index, values);
              },
              }
            }*/
              x: {  
                type: 'time',
                time: {
                  parser: 'YYYY/MM/DD',
                  unit: 'day',
                  displayFormats: {
                    'day': 'DD/MM/YYYY',
                    'month' : 'DD/MM/YYYY'
                  },
                },
                ticks:{
                  color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
                  font: {
                    size: 10, // 'size' now within object 'font {}'
                  },
                  //stepSize: 7,
                  callback: function(value, index, values) {
                      //console.log("value", value, index, semanas[index], values);
                      return exibeMesAnoGrafico(index, values);
                      
                  },
                },
                grid: {
                    color: theme === "dark" ? "#5d5f69" : '#ccc',
                },
                min: datas != null ? datas[minIdxDate] : null,
                max: datas != null ? datas[maxIdxDate] : null,
              }
          },
        };
  
  const options2 = {
    animation: false,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        onClick: (e, legendItem, legend) => {
          //console.log(legendItem.datasetIndex);

        },
        position: 'bottom',
        align: 'start',
        labels: {
          boxWidth: 15,
          color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
          font: { 
            size: 10
          }
        }
      },
      title: {
        display: false,
        color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
        text: 'Chart.js Line Chart',
      },
      /*annotation: {
        annotations: [
          {
            type: 'line',
            mode: 'vertical',
            scaleID: 'x',
            value: "2024-03-02",
            borderColor: corLinhaMarcaoGrafico,
            borderWidth: 1,
          },
        ],
      },*/
    },
    scales: {
      y:{
        type: 'linear',
        display: true,
        position: 'left',
        id: 'y-axis-1',
        labelString: 'Dataset 1',
        afterBuildTicks: function(scale) {
          scale.ticks.forEach(function(tick, index, ticks) {
            ticks[index].color = 'rgba(75,192,192,1)'; // Cor da escala do primeiro eixo y
          });
        },
        title: {
          display: true,
          text: t("dashboard.graficos.titulo_atendimento_gripais"), // Texto do título do eixo Y
          color: theme === "dark" ? "#FFFFFF" : "#000000",
          font: {
              size: 12,
              weight: 'bold'
          }
        },
        grid: {
                    color: theme === "dark" ? "#5d5f69" : '#ccc',
                },
      },
      y2:{
        type: 'linear',
          display: true,
          position: 'right',
          id: 'y-axis-2',
          labelString: 'Dataset 2',
          afterBuildTicks: function(scale) {
            scale.ticks.forEach(function(tick, index, ticks) {
              ticks[index].color = 'rgba(255, 99, 132, 1)'; // Cor da escala do segundo eixo y
            });
          },
          title: {
            display: true,
            text: t("dashboard.variaveisGoogle.termos"), // Texto do título do eixo Y
            color: theme === "dark" ? "#FFFFFF" : "#000000",
            font: {
                size: 12,
                weight: 'bold'
            }
          },
          grid: {
                    color: theme === "dark" ? "#5d5f69" : '#ccc',
                },
      },
      /*x:{
        type: 'time',
        time: {
          parser: 'YYYY/MM/DD',
          unit: 'day',
          displayFormats: {
            'day': 'DD/MM/YYYY',
            'month' : 'DD/MM/YYYY'
          },
        },
        ticks:{
          callback: function(value, index, values) {
            // Converte a data em um objeto moment
           
            return exibeMesAnoGrafico(index, values);
        },
        }
      }*/
        x: {  
          type: 'time',
          time: {
            parser: 'YYYY/MM/DD',
            unit: 'day',
            displayFormats: {
              'day': 'DD/MM/YYYY',
              'month' : 'DD/MM/YYYY'
            },
          },
          ticks:{
            color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
            font: {
              size: 10, // 'size' now within object 'font {}'
            },
            //stepSize: 7,
            callback: function(value, index, values) {
                
                return exibeMesAnoGrafico(index, values);
                
            },
          },
          grid: {
                    color: theme === "dark" ? "#5d5f69" : '#ccc',
                },
          min: datas != null ? datas[minIdxDate] : null,
          max: datas != null ? datas[maxIdxDate] : null,
        }
    },
  };
  

  function extraiAno(data){
    if(data && data.length > 0)
        return data.substring(0,4);
    else 
        return "";
  }

  let mdbootstrap = 12;

  function getCidades(somenteNomes) {
    var nomes_municipios = [];

    if(somenteNomes){
        nomes_municipios.unshift(
          t("dashboard.todos")
        );
        nomes_municipios.sort((a, b) => a.localeCompare(b));
    } else {
        nomes_municipios.unshift({
            "cod_ibge": 0,
            "municipio": t("dashboard.todos")
        });
        nomes_municipios.sort((a, b) => a["municipio"].localeCompare(b["municipio"]));
    }

    return nomes_municipios;
}

  const [loading, setLoading] = useState(true);
  const [cod_ibge, setCod_Ibge] = useState(t("dashboard.todos"));
  const [municipioSelecionado, setMunicipioSelecionado] = useState(t("dashboard.todos"));
  const [estadoSelecionado, setEstadoSelecionado] = useState(t("dashboard.todos"));

  const [cidades_labels, setCidades_Labels] = useState([{cod_ibge: t("dashboard.todos"), label: t("dashboard.todos")}]);
  const [listaMunicipios, setListaMunicipios] = useState(getCidades());
  const baseUrl = window.location.origin;
  const arbovUrl = `${baseUrl}/arbov`;
  const [link_zika, setLink_Zika] = useState(arbovUrl);
  var link_gripe = "#";
  let dengue = true;

  var defaultPropsMunicipio = {
      options: cidades_labels,
      getOptionLabel: (option) => option.label,
  };

  var estados_labels = [
    {label:t("dashboard.todos")},
    {label:"Acre"},
    {label:"Alagoas"},
    {label:"Amapá"},
    {label:"Amazonas"},
    {label:"Bahia"},
    {label:"Ceará"},
    {label:"Distrito Federal"},
    {label:"Espírito Santo"},
    {label:"Goiás"},
    {label:"Maranhão"},
    {label:"Mato Grosso"},
    {label:"Mato Grosso do Sul"},
    {label:"Minas Gerais"},
    {label:"Pará"},
    {label:"Paraíba"},
    {label:"Paraná"},
    {label:"Pernambuco"},
    {label:"Piauí"},
    {label:"Rio de Janeiro"},
    {label:"Rio Grande do Norte"},
    {label:"Rio Grande do Sul"},
    {label:"Rondônia"},
    {label:"Roraima"},
    {label:"Santa Catarina"},        
    {label:"São Paulo"},
    {label:"Sergipe"},
    {label:"Tocantins"},
];

var defaultProps = {
    options: estados_labels,
    getOptionLabel: (option) => option.label,
};

const getNomeCidadeWhereCodIbge = (cod_ibge) => {
  for (let index = 0; index < cidades_labels.length; index++) {
    const element = cidades_labels[index];
    if(element["cod_ibge"] === cod_ibge){
        return element["label"];
    }
  }
  return t("dashboard.todos");
};

const getCodIbgeCidadeWhereNome = (nome) => {
  if(municipios){
    for (let index = 0; index < municipios.length; index++) {
      const element = municipios[index];
      if(element["MUNICIPIO"].toLowerCase() === nome.toLowerCase()){
          return element["COD_IBGE"];
      }
    }
  } 
  return 0;
}

const handleChangeMunicipioNome = (nome_municipio) => {
  //voltar aqui
  setCod_Ibge(nome_municipio);
  setMunicipioSelecionado(getNomeCidadeWhereCodIbge(nome_municipio));
  localStorage.setItem('estadoSelecionadoDashboard', estadoSelecionado);
  localStorage.setItem('codibgeMunicipioSelecionadoDashboard', nome_municipio);
  localStorage.setItem('municipioSelecionadoDashboard', getNomeCidadeWhereCodIbge(nome_municipio));
};

useEffect(() => {
  if(!iniciou){
    return;
  }
  //console.log("useEffect estadoSelecionado, municipioSelecionado...", getHora());
  //console.log("estadoSelecionado", estadoSelecionado, "municipioSelecionado", municipioSelecionado);
      
  if(estadoSelecionado){
    
    let siglaEstado = "";
    let codEstado = "";
    for (let index = 0; index < cod_estados.length; index++) {
      const element = cod_estados[index];
      //compare em minusculo
      if(element["NOME"].toLowerCase() === estadoSelecionado.toLowerCase()){
          siglaEstado = element["UF"];
          codEstado = element["COD"];
          codEstado = codEstado.toString();
          break;
      }
    }

    //console.log("siglaEstado", siglaEstado, "codEstado", codEstado);
    
    carregaMunicipiosPorEstado(siglaEstado);
    if(!isAllSelect(estadoSelecionado) && isAllSelect(municipioSelecionado)){
      carregaDadosMunicipio(codEstado);
    }
    else
    if(isAllSelect(estadoSelecionado)){  
      setCidades_Labels([{cod_ibge: t("dashboard.todos"), label: t("dashboard.todos")}]);
  
      if(listaMunicipios.length === 1){
        setListaMunicipios(getCidades());
      }

      carregaDadosMunicipio(t("dashboard.todos"));
    }
    else {
      //console.log("carregaDadosMunicipio", getCodIbgeCidadeWhereNome(municipioSelecionado));
      carregaDadosMunicipio(getCodIbgeCidadeWhereNome(municipioSelecionado));
    }
  }
}, [estadoSelecionado, municipioSelecionado]);

/*
useEffect(() => {
  if(cod_ibge === t("dashboard.todos") && estadoSelecionado === t("dashboard.todos")){
    console.log("[cod_ibge]");
    carregaDadosMunicipio(t("dashboard.todos"));
  } 
  else   
  if(!isAllSelect(cod_ibge)){
    carregaDadosMunicipio(cod_ibge);
    //console.log("2");
  }
}, [cod_ibge]); */

function carregaMunicipiosPorEstado(siglaEstado){
  if(!loading){
      setLoading(true);
  }

  if(siglaEstado !== ''){
      fetch(servidor + '/api/municipio/municipiosbysiglaestado/'+siglaEstado
          , {
              headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'Authorization': 'Bearer ' + _logado
              }
          }
      )
      .then(response => {
        if (response.status === 401 || response.status === 404) {
          setLogado(null);    
          window.location.href = "/";
        }
        return response.json();
      })
      .then(function (myJson) {
          let listaTemp = [];
          let cidades_labels_tmp = [{cod_ibge: t("dashboard.todos"), label: t("dashboard.todos")}];
          for(let i = 0; i < myJson.length; i++){
              listaTemp.push({
                  "cod_ibge": myJson[i]["cod_ibge"],
                  "municipio": myJson[i]["municipio"],
                  "latitude": myJson[i]["y"],
                  "longitude": myJson[i]["x"]
              });

              cidades_labels_tmp.push({cod_ibge: myJson[i]["cod_ibge"],  label: myJson[i]["municipio"]});
          }

          setCidades_Labels(cidades_labels_tmp);

          listaTemp.sort((a, b) => a["municipio"].localeCompare(b["municipio"]));
          
          listaTemp.unshift({
              "cod_ibge": 0,
              "municipio": t("dashboard.todos")
          });

          setListaMunicipios(listaTemp); 

      });
  }
}

  //deixe o acordion aberto
  const [open, setOpen] = useState(true);

  const [listaMediaMovel, setlistaMediaMovel] = useState(
  [
    {"sinal": "1", "nome": "1 Semana"},
    {"sinal": "2", "nome": "2 Semanas"},
    {"sinal": "3", "nome": "3 Semanas"},
    {"sinal": "4", "nome": "4 Semanas"},
  ]);

  const [listaVariavelMediaMovel, setListaVariavelMediaMovel] = useState(
    [
      {"sinal": "1", "nome": t("dashboard.variaveisGoogle.coriza")},
      {"sinal": "2", "nome": t("dashboard.variaveisGoogle.covid")},
      {"sinal": "3", "nome": t("dashboard.variaveisGoogle.diarreia")},
      {"sinal": "4", "nome": t("dashboard.variaveisGoogle.dor_de_cabeca")},
      {"sinal": "5", "nome": t("dashboard.variaveisGoogle.dor_de_garganta")},
      {"sinal": "6", "nome": t("dashboard.variaveisGoogle.falta_de_ar")},
      {"sinal": "7", "nome": t("dashboard.variaveisGoogle.febre")},
      {"sinal": "8", "nome": t("dashboard.variaveisGoogle.gripe")},
      {"sinal": "9", "nome": t("dashboard.variaveisGoogle.resfriado")},
      {"sinal": "10", "nome": t("dashboard.variaveisGoogle.tosse")},
      {"sinal": "11", "nome": t("dashboard.variaveisGoogle.vomito")},
    ]);

  const handleChangeMediaMovel = (event) => {
    setMediaMovelSelecionada(event.target.value);
  };

  const handleChangeVariavelMediaMovel = (event) => {
    setVariavelMediaMovelSelecionada(event.target.value);
  };

  useEffect(() => {
    if(dadosCoriza.current){
      atualizaMediaMovel();
    }
  }, [mediaMovelSelecionada, variavelMediaMovelSelecionada]);

  let val_Var = [
      t("dashboard.variaveisGoogle.coriza"),
      t("dashboard.variaveisGoogle.covid"),
      t("dashboard.variaveisGoogle.diarreia"),
      t("dashboard.variaveisGoogle.dor_de_cabeca"),
      t("dashboard.variaveisGoogle.dor_de_garganta"),
      t("dashboard.variaveisGoogle.falta_de_ar"),
      t("dashboard.variaveisGoogle.febre"),
      t("dashboard.variaveisGoogle.gripe"),
      t("dashboard.variaveisGoogle.resfriado"),
      t("dashboard.variaveisGoogle.tosse"),
      t("dashboard.variaveisGoogle.vomito"),
  ];

  var [selectedVar, setSelectedVar] = useState(val_Var);

  useEffect(() => {

    var varTemp = [t("dashboard.variaveisGoogle.coriza"),
    t("dashboard.variaveisGoogle.covid"),
    t("dashboard.variaveisGoogle.diarreia"),
    t("dashboard.variaveisGoogle.dor_de_cabeca"),
    t("dashboard.variaveisGoogle.dor_de_garganta"),
    t("dashboard.variaveisGoogle.falta_de_ar"),
    t("dashboard.variaveisGoogle.febre"),
    t("dashboard.variaveisGoogle.gripe"),
    t("dashboard.variaveisGoogle.resfriado"),
    t("dashboard.variaveisGoogle.tosse"),
    t("dashboard.variaveisGoogle.vomito")];

    if(selectedVar.includes(varTemp[0])){
      setOcultaCoriza(false);
    } else {
      setOcultaCoriza(true);
    }

    if(selectedVar.includes(varTemp[1])){
      setOcultaCovid(false);
    } else {
      setOcultaCovid(true);
    }

    if(selectedVar.includes(varTemp[2])){
      setOcultaDiarreia(false);
    } else {
      setOcultaDiarreia(true);
    }

    if(selectedVar.includes(varTemp[3])){
      setOcultaDorDeCabeca(false);
    } else {
      setOcultaDorDeCabeca(true);
    }

    if(selectedVar.includes(varTemp[4])){
      setOcultaDorDeGarganta(false);
    } else {
      setOcultaDorDeGarganta(true);
    }

    if(selectedVar.includes(varTemp[5])){
      setOcultaFaltaDeAr(false);
    } else {
      setOcultaFaltaDeAr(true);
    }

    if(selectedVar.includes(varTemp[6])){
      setOcultaFebre(false);
    } else {
      setOcultaFebre(true);
    }

    if(selectedVar.includes(varTemp[7])){
      setOcultaGripe(false);
    } else {
      setOcultaGripe(true);
    }

    if(selectedVar.includes(varTemp[8])){
      setOcultaResfriado(false);
    } else {
      setOcultaResfriado(true);
    }

    if(selectedVar.includes(varTemp[9])){
      setOcultaTosse(false);
    } else {
      setOcultaTosse(true);
    }

    if(selectedVar.includes(varTemp[10])){
      setOcultaVomito(false);
    } else {
      setOcultaVomito(true);
    }

  }, [selectedVar]);

  useEffect(() => {
    if(!iniciou){
      return;
    }
    //console.log("UseEffect");
    let exibe = [true, true, true, true, true, true, true, true, true, true, true];

    let termosPrioridade = ["covid", "gripe", "febre", "tosse", "diarreia", "dor_de_cabeca", "resfriado", "falta_de_ar", "dor_de_garganta", "coriza", "vomito"];

    if(!prioridade.current || prioridade.current.length === 0){
      //console.log("prioridade.current.length === 0");
      return;
    }

    for (let index = 0; index < termosPrioridade.length; index++) {
      const element = termosPrioridade[index];
      let idx = prioridade.current.findIndex(x => x["nome"].toLowerCase() === element);
      if(idx >= 0){
        exibe[index] = true;
      }
    }

    /*console.log(selectedVar, prioridade.current);

    let exibe0 = !getOcultar(prioridade.current[0]["nome"]) ? prioridade.current[0]["nome"] : "";
    let exibe1 = !getOcultar(prioridade.current[1]["nome"]) ? prioridade.current[1]["nome"] : "";
    let exibe2 = !getOcultar(prioridade.current[2]["nome"]) ? prioridade.current[2]["nome"] : "";
    let exibe3 = !getOcultar(prioridade.current[3]["nome"]) ? prioridade.current[3]["nome"] : "";
    let exibe4 = !getOcultar(prioridade.current[4]["nome"]) ? prioridade.current[4]["nome"] : "";
    let exibe5 = !getOcultar(prioridade.current[5]["nome"]) ? prioridade.current[5]["nome"] : "";
    let exibe6 = !getOcultar(prioridade.current[6]["nome"]) ? prioridade.current[6]["nome"] : "";
    let exibe7 = !getOcultar(prioridade.current[7]["nome"]) ? prioridade.current[7]["nome"] : "";
    let exibe8 = !getOcultar(prioridade.current[8]["nome"]) ? prioridade.current[8]["nome"] : "";
    let exibe9 = !getOcultar(prioridade.current[9]["nome"]) ? prioridade.current[9]["nome"] : "";
    let exibe10 = !getOcultar(prioridade.current[10]["nome"]) ? prioridade.current[10]["nome"] : "";*/

    //pegue o ultimo valor de dadosMediaAtendimentoTodos.datasets[1].data via keys

    //console.log("chamada atualizaGraficoRelativo useSeffect oculta....", getHora());
    atualizaGraficoRelativo([exibe[0], exibe[1], exibe[2], exibe[3], exibe[4], exibe[5], exibe[6], exibe[7], exibe[8], exibe[9], exibe[10]]);
  }, [ocultaCoriza, ocultaCovid, ocultaDiarreia, ocultaDorDeCabeca, ocultaDorDeGarganta, ocultaFaltaDeAr, ocultaFebre, ocultaGripe, ocultaResfriado, ocultaTosse, ocultaVomito]);

  const valorNil = "nil";

  const fixaCasasDecimais = (valor, casasDecimais) => {
    if(valor === valorNil) 
        return valorNil;

    if (typeof valor === 'string') {
        valor = parseFloat(valor.replace(',', '.'));
    }
    const fator = Math.pow(10, casasDecimais);
    const valorArredondado = Math.round(valor * fator) / fator;
    return valorArredondado.toFixed(casasDecimais);
    /*return parseFloat(valor).toFixed(casasDecimais).replace(',', '.');*/
  }

  const getUltimoValorTermo = (termo) => {
    switch (variavelMediaMovelSelecionada) {
      case "1":
        return ultimoValorCoriza;
      case "2":
        return ultimoValorCovid;
      case "3":
        return ultimoValorDiarreia;
      case "4":
        return ultimoValorDorDeCabeca;
      case "5":
        return ultimoValorDorDeGarganta;
      case "6":
        return ultimoValorFaltaDeAr;
      case "7":
        return ultimoValorFebre;
      case "8":
        return ultimoValorGripe;
      case "9":
        return ultimoValorResfriado;
      case "10":
        return ultimoValorTosse;
      case "11":
        return ultimoValorVomito;
  }}

  const getUltimoValorTermoMM = (termo) => {
    switch (variavelMediaMovelSelecionada) {
      case "1":
        return ultimoValorCorizaMM;
      case "2":
        return ultimoValorCovidMM;
      case "3":
        return ultimoValorDiarreiaMM;
      case "4":
        return ultimoValorDorDeCabecaMM;
      case "5":
        return ultimoValorDorDeGargantaMM;
      case "6":
        return ultimoValorFaltaDeArMM;
      case "7":
        return ultimoValorFebreMM;
      case "8":
        return ultimoValorGripeMM;
      case "9":
        return ultimoValorResfriadoMM;
      case "10":
        return ultimoValorTosseMM;
      case "11":
        return ultimoValorVomitoMM;
  }}
  return (
    <div className="container_google_trend">
      <TabNav theme={theme} language={language} currentPage={"Web Based"} link_gripe="" link_zika= {link_zika}/>
      <br></br>
      <Accordion   defaultActiveKey="0">
      <Accordion.Item  eventKey="0" >
        <Accordion.Header className={theme === "dark" ? "header-dark" : "header-light"}>Google Trends</Accordion.Header>
        <Accordion.Body  className={theme === "dark" ? "bg-dark text-white" : "bg-light text-dark"}>
            <Container className='container_webbased'>
                <div className={style.seleciona_periodo_semana}>
                    <div className='titulo_semana_ep'>
                      <Translator path="dashboard.semana_ep" />: {FormatarDoisDigitos(inicioSemanaSelecionadaRange)+ "-" + extraiAno(minDateRangeFinal)}&nbsp; a &nbsp;{FormatarDoisDigitos(fimSemanaSelecionadaRange)+ "-" + extraiAno(maxDateRangeFinal)}
                    </div>
                </div>
                <div className={style.seleciona_periodo}>
                    <div className='dataSemanaRange'>
                        <Moment date={minDateRangeInicial} format='DD/MM/YYYY'></Moment>&nbsp; a &nbsp;<Moment date={minDateRangeFinal} format='DD/MM/YYYY'></Moment>
                    </div>
                    <Box sx={{ width: "220px", paddingTop:"0px", marginTop:"-5px" }}>
                        <Slider
                            getAriaLabel={() => 'Date range'}
                            value={valueRangeData}
                            onChange={handleChangeRangeData}
                            valueLabelDisplay="off"
                            min={0}
                            max={datas != null ? datas.length - 1 : 0}
                        />
                    </Box>
                    <div className='dataSemanaRange'>
                        <Moment date={maxDateRangeInicial} format='DD/MM/YYYY'></Moment>&nbsp; a &nbsp;<Moment date={maxDateRangeFinal} format='DD/MM/YYYY'></Moment>
                    </div>
                </div>
                
                <div className={style.seleciona_municipio}> 
                  <Autocomplete
                      {...defaultProps}
                      disableClearable
                      id="autocomplete_estado"
                      className='change_color_text'
                      isOptionEqualToValue={(option, value) => option.label === value.label}
                      value={{label:estadoSelecionado}}
                      style={{ width: 300 }}
                      onChange={(event, newValue) => {
                        //voltar aqui
                          setLoading(true);
                          setEstadoSelecionado(newValue.label);
                          setCod_Ibge(t("dashboard.todos"));
                          setMunicipioSelecionado(t("dashboard.todos"));
                          localStorage.setItem('estadoSelecionadoDashboard', newValue.label);
                          localStorage.setItem('codibgeMunicipioSelecionadoDashboard', t("dashboard.todos"));
                          localStorage.setItem('municipioSelecionadoDashboard', t("dashboard.todos"));
                      }}
                      renderInput={(params) => (
                          <TextField className='autocomplete_estado_textfield' {...params} label={t("dashboard.estado")} size="small"/>
                      )}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  
                  <Autocomplete
                      {...defaultPropsMunicipio}
                      disableClearable
                      id="autocomplete_municipio"
                      className='change_color_text'
                      isOptionEqualToValue={(option, value) => option.cod_ibge === value.cod_ibge}
                      value={{cod_ibge:cod_ibge, label:municipioSelecionado}}
                      style={{ width: 300 }}
                      onChange={(event, newValue) => {
                          handleChangeMunicipioNome(newValue.cod_ibge);
                      }}
                      renderInput={(params) => (
                          <TextField {...params} label={t("dashboard.cidade")} size="small"/>
                      )}
                  />

{/*
                  <FormControl id="multipleselect_form" >
                      <InputLabel>{t("dashboard.variaveisGoogle.termos")}</InputLabel>
                      <Select
                          id="multipleselect_select"
                          multiple
                          value={selectedVar}
                          sx={{ width: 440}}
                          onChange={(e) => setSelectedVar(e.target.value)}
                          input={<OutlinedInput label={t("dashboard.variaveisGoogle.termos")} />}
                          renderValue={(selected) => (
                              selectedVar.length +" / 11 Selecionados"
                              <Stack id="multipleselect_stack" gap={1} direction="row"  flexWrap="nowrap">
                                  {selected.slice(0,3).map((value) => (
                                  <Chip
                                      id="multipleselect_chip"
                                      key={value}
                                      label={value}
                                      sx={theme === "dark" ? { color: "white", backgroundColor: "#2f3136" } : {  }}
                                      onDelete={() => {   
                                              if(value !== t("dashboard.mobilidade")){
                                                  setSelectedVar(
                                                      selectedVar.filter((item) => item !== value)
                                                  );
                                              }
                                          }
                                      }
                                      deleteIcon={
                                          <CancelIcon
                                              id="multipleselect_cancelicon"
                                              onMouseDown={(event) => event.stopPropagation()}
                                          />
                                      }
                                  />
                                  ))}
                              </Stack>
                          )}
                          
                      >
                          {val_Var.map((name) => (
                              
                          <MenuItem
                              key={name}
                              value={name}
                              sx={{ justifyContent: "space-between"}}
                          >
                              {name}
                              {selectedVar.includes(name) ? <CheckIcon id="multipleselect_checkicon" color="info" /> : null}
                          </MenuItem>
                          ))}
                      </Select>
                      
                  </FormControl>*/}
              </div>
              
                
              <br></br>
              <div className="container_grafico_dash_web">
                  <div className="header_grafico">
                      {t("dashboard.graficos.titulo_mm") + " vs " + t("dashboard.variaveisGoogle.termos") }
                      <img className="img_info ocultar" src="flu/imagens/info32.png"></img>
                  </div>
                  <div className="body_grafico_resumo_grafico_web" style={{backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                      <Row style={{minWidth: "100%", maxWidth:"100%", minHeight:"410px", maxHeight:"100%"}}>
                          <Col md={9}>
                              <Line className={`${style.grafico_pg}`} options={options} data={dadosAtendimentoTodos} />
                          </Col>
                          <Col md={3}>
                              <div className="resumo_grafico" style={{color:  theme === "dark" ? "white" : "black" ,backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                  <div className={style.titulo_resumo_grafico}>
                                      {t("dashboard.semana_ep")+" "} {semanas[semanas.length - 1]} 
                                  </div>
                                  <center>
                                  <FormControl id="multipleselect_form_web_based" >
                                    <InputLabel>{t("dashboard.variaveisGoogle.termos")}</InputLabel>
                                    <Select
                                        id="multipleselect_select"
                                        multiple
                                        value={selectedVar}
                                        sx={{ width: 150}}
                                        onChange={(e) => setSelectedVar(e.target.value)}
                                        input={<OutlinedInput label={t("dashboard.variaveisGoogle.termos")} />}
                                        renderValue={(selected) => (
                                            <Stack id="multipleselect_stack" gap={1} direction="row"  flexWrap="wrap">
                                                {selected.map((value) => (
                                                <Chip
                                                    id="multipleselect_chip"
                                                    key={value}
                                                    label={value}
                                                    sx={theme === "dark" ? { color: "white", backgroundColor: "#2f3136" } : {  }}
                                                    onDelete={() => {   
                                                            if(value !== t("dashboard.mobilidade")){
                                                                setSelectedVar(
                                                                    selectedVar.filter((item) => item !== value)
                                                                );
                                                            }
                                                        }
                                                    }
                                                    deleteIcon={
                                                        <CancelIcon
                                                            id="multipleselect_cancelicon"
                                                            onMouseDown={(event) => event.stopPropagation()}
                                                        />
                                                    }
                                                />
                                                ))}
                                            </Stack>
                                        )}
                                        
                                    >
                                        {val_Var.map((name) => (
                                            
                                        <MenuItem
                                            key={name}
                                            value={name}
                                            sx={{ justifyContent: "space-between"}}
                                        >
                                            {name}
                                            {selectedVar.includes(name) ? <img src='/flu/imagens/check.png' style={{width:'15px', height:'15px'}} /> : null}
                                        </MenuItem>
                                        ))}
                                    </Select>
                                    
                                  </FormControl>
                                  </center>
                                  {/*<div className={style.valor_resumo_container}>
                                      <div className="valor_resumo" style={{color:  theme === "dark" ? "white" : "black" ,backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                          {fixaCasasDecimais(dadosAtendimentoTodos.datasets[0].data[fimSemanas[semanas.length-1]],2)}  %
                                      </div>
                                      {dadosAtendimentoTodos.datasets[0].label}
                                  </div>
                                  <div className={style.valor_resumo_container}>
                                      <div className="valor_resumo" style={{color:  theme === "dark" ? "white" : "black" ,backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                          {fixaCasasDecimais(dadosAtendimentoTodos.datasets[1].data[fimSemanas[semanas.length-1]],2)}  %
                                      </div>
                                      {dadosAtendimentoTodos.datasets[1].label} 
                                  </div>*/}
                              </div>
                          </Col>
                      </Row>
                  
                  </div>
              </div>   
              
              <Row>
                {/*
                <Col md={mdbootstrap}>
                  <div className="grafico_g">
                    <Line ref={chartRef} data={dadosAtendimentoTodos} options={options} />
                  </div>
                </Col>
                */}
                <div style={{marginTop:30, marginBottom:10}}>
                  <FormControl id="controle-selecao-var-media-movel">
                    <InputLabel id="demo-simple-select-label">{t("dashboard.variavel")}</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={variavelMediaMovelSelecionada}
                      onChange={handleChangeVariavelMediaMovel}
                      label={t("dashboard.variavel")}
                      name={"variavel_media_movel"}
                      sx={{ width: 160, height: 32}}
                    >
                    {listaVariavelMediaMovel.map((e, key) => {
                      return (
                        <MenuItem key={key} value={e["sinal"]}>{e["nome"]}</MenuItem>
                      );
                    })}
                    </Select>
                  </FormControl>
                  <FormControl id="controle-selecao-indicador">
                    <InputLabel id="demo-simple-select-label">{t("dashboard.graficos.legenda_mm.1")}</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={mediaMovelSelecionada}
                      onChange={handleChangeMediaMovel}
                      label={t("dashboard.graficos.legenda_mm.1")}
                      name={"media_movel"}
                      sx={{ width: 120, height: 32}}
                    >
                    {listaMediaMovel.map((e, key) => {
                      return (
                        <MenuItem key={key} value={e["sinal"]}>{e["nome"]}</MenuItem>
                      );
                    })}
                    </Select>
                  </FormControl> 
                </div>
                <div className="container_grafico_dash_web">
                  <div className="header_grafico">
                      {t("dashboard.graficos.titulo_mm") + " vs " + t("dashboard.variaveisGoogle.termos") + " vs " + t("dashboard.variaveisGoogle.termos") + " " + t("dashboard.graficos.legenda_mm.1")}
                      <img className="img_info ocultar" src="flu/imagens/info32.png"></img>
                  </div>
                  <div className="body_grafico_resumo_grafico_web" style={{backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                      <Row style={{minWidth: "100%", maxWidth:"100%", minHeight:"410px", maxHeight:"100%"}}>
                          <Col md={9}>
                              <Line className={`${style.grafico_pg}`} options={options2} data={dadosMediaAtendimentoTodos} />
                          </Col>
                          <Col md={3}>
                              <div className="resumo_grafico" style={{color:  theme === "dark" ? "white" : "black" ,backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                  <div className={style.titulo_resumo_grafico}>
                                      {t("dashboard.semana_ep")+" "} {semanas[semanas.length - 1]} 
                                  </div>

                                  <div className={style.valor_resumo_container}>
                                      <div className={style.valor_resumo} style={{color:  theme === "dark" ? "white" : "black" ,backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                          {dadosMediaAtendimentoTodos.datasets[0].data !== null ? dadosMediaAtendimentoTodos.datasets[0].data[Object.keys(dadosMediaAtendimentoTodos.datasets[0].data)[Object.keys(dadosMediaAtendimentoTodos.datasets[0].data).length-1]] : ""} 
                                      </div>
                                      {dadosMediaAtendimentoTodos.datasets[0].label}
                                  </div>
                                  <div className={style.valor_resumo_container}>
                                      <div className={style.valor_resumo} style={{color:  theme === "dark" ? "white" : "black" ,backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                          {!dadosMediaAtendimentoTodos.datasets[1].data[Object.keys(dadosMediaAtendimentoTodos.datasets[1].data)[Object.keys(dadosMediaAtendimentoTodos.datasets[1].data).length-1]] && 0}
                                          {dadosMediaAtendimentoTodos.datasets[1].data[Object.keys(dadosMediaAtendimentoTodos.datasets[1].data)[Object.keys(dadosMediaAtendimentoTodos.datasets[1].data).length-1]] && dadosMediaAtendimentoTodos.datasets[1].data !== null ? fixaCasasDecimais(dadosMediaAtendimentoTodos.datasets[1].data[Object.keys(dadosMediaAtendimentoTodos.datasets[1].data)[Object.keys(dadosMediaAtendimentoTodos.datasets[1].data).length-1]], 2) : ""}  %
                                          
                                      </div>
                                      {dadosMediaAtendimentoTodos.datasets[1].label}
                                  </div>
                                  <div className={style.valor_resumo_container}>
                                      <div className={style.valor_resumo} style={{color:  theme === "dark" ? "white" : "black" ,backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                          {fixaCasasDecimais(getUltimoValorTermoMM(variavelMediaMovelSelecionada) ,2)}  %
                                      </div>
                                      {dadosMediaAtendimentoTodos.datasets[2].label} 
                                  </div>
                              </div>
                          </Col>
                      </Row>
                  
                  </div>
              </div>  
                {/*<Col md={mdbootstrap}>
                  <div className="grafico_g">
                    <Line data={dadosMediaAtendimentoTodos} options={options2} />
                  </div>
                </Col>*/}
              </Row>
          
            </Container>
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
      <br></br>
    </div>
  );

}

export default WebBased;